(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var _memoize = require(3);
var wrapper = require(4);

function memoize(getKey) {
  return _memoize(wrapper, getKey);
}

module.exports = memoize;

});
},{"3":3,"4":4,"8":8}],2:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var _retry = require(5);
var wrapper = require(4);

function retry(times, interval, error) {
  return _retry(wrapper, times, interval, error);
}

module.exports = retry;

});
},{"4":4,"5":5,"8":8}],3:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var defaultLogger = require(7);
var keyGetter = require(136);

function memoizeDecorator(wrapper, getKey) {
  getKey = keyGetter(getKey || function () { return '_default'; });
  return wrapper(function (func) {
    var cache = {};
    return function () {
      var context = this;
      var args = Array.prototype.slice.call(arguments, 0);
      var logger = defaultLogger.apply(context);
      var cb = args[args.length - 1];
      var cacheKey = getKey.apply(context, args);
      args[args.length - 1] = function (err, dep) {
        if (!err && cacheKey !== null) {
          cache[cacheKey] = dep;
        }
        cb(err, dep);
      };
      if (cacheKey !== null && cacheKey in cache) {
        logger('memoize-hit', {key: cacheKey, result: cache[cacheKey]});
        return cb(null, cache[cacheKey]);
      }
      else {
        func.apply(context, args);
      }
    };
  });
}

module.exports = memoizeDecorator;

});
},{"136":136,"7":7,"8":8}],4:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var promisify = require(133);
var callbackify = require(6);

// it works for decorator(f) and decorator([f1, f2, f3 ...])

function promiseTranslator(decorator) {
  return function (f) { // f returns a promise
    var cb;
    if (Array.isArray(f)) {
      cb = f.map(callbackify);
    } else {
      cb = callbackify(f);
    }

    return promisify(decorator(cb));
  };
}

module.exports = promiseTranslator;

});
},{"133":133,"6":6,"8":8}],5:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var defaultLogger = require(7);

function retryDecorator(wrapper, times, interval, error) {
  var condition;
  times = times || Infinity;
  error = error || Error;
  interval = interval || 0;
  var intervalFunc = typeof interval === 'function' ?
    interval :
    function () { return interval; };

  if (error === Error || Error.isPrototypeOf(error)) {
    condition = function (err, dep) { return err instanceof error; };
  }
  else {
    condition = error;
  }

  return wrapper(function (func) {
    return function () {
      var counter = 0;
      var context = this;
      var args = Array.prototype.slice.call(arguments, 0);
      var logger = defaultLogger.apply(context);
      var cb = args[args.length - 1];

      var retry = function () {
        if (counter++ && intervalFunc(counter) > 0) { // do not wait for counter === 0
          setTimeout(function () {
            func.apply(context, args);
          }, interval);
        }
        else {
          func.apply(context, args);
        }
      };

      args[args.length - 1] = function (err, dep) {
        if (condition(err, dep) && counter < times) {
          logger('retry', {
            times: counter,
            actualResult: {err: err, res: dep}
          });
          retry();
        }
        else {
          cb(err, dep);
        }
      };
      retry();
    };
  });
}

module.exports = retryDecorator;

});
},{"7":7,"8":8}],6:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
function isPromise(obj) {
  return typeof obj === 'object' && 'then' in obj;
}

function callbackify(func) {
  return function () {
    // get arguments
    var context = this;
    var args = Array.prototype.slice.call(arguments, 0, -1);
    var cb = arguments[arguments.length - 1];
    try {
      var output = func.apply(context, args);
    }
    catch (e) {
      return cb(e);
    }

    if (isPromise(output)) {
      output.then(function (res) { // onfulfilled
        cb(null, res);
      },
      function (error) { // onrejected
        cb(error);
      });
    }
    else {
      cb(null, output);
    }
  };
}

module.exports = callbackify;

});
},{"8":8}],7:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function () {
  if (typeof this === 'object' && '__log' in this) {
    return this.__log;
  }
  return function () {};
};

});
},{"8":8}],8:[function(require,module,exports){
(function (global){
(function (cb){
  var w;
  try {
    w = window;
  } catch (e) {
    w = global;
  }

  var queue = w._async_define_queue = '_async_define_queue' in w ? w._async_define_queue : [];
  var cached_dependencies = w._async_define_cached_dependencies = '_async_define_cached_dependencies' in w ? w._async_define_cached_dependencies : {};

  function getDepsArray(depNames) {
    var i,
      tmp, depNS, depProp,
      len = depNames.length,
      deps = [];

    for (i = 0; i < len; i++) {
      tmp = depNames[i].split('|');
      depNS = tmp[0];
      depProp = tmp[1];
      if (depNS in cached_dependencies){
        deps.push(depProp ? cached_dependencies[depNS][depProp] : cached_dependencies[depNS]);
      }
      else {
        return;
      }
    }
    return deps;
  }

  function runThroughQueue() {
    while (_runThroughQueue());
  }

  function _runThroughQueue() {
    var i = 0;
    var solvedDependency = false;
    while (i < queue.length){
      if (execute(queue[i])){
        if (queue[i].name){
          solvedDependency = true;
        }
        queue.splice(i, 1);
      }
      else {
        i++;
      }
    }
    return solvedDependency;
  }

  function execute (item){
    if (item.name in cached_dependencies) { // don't execute twice
      return true;
    }
    var deps = getDepsArray(item.depNames);
    var exp;
    if (deps){
      exp = item.func.apply(w, deps);
      if (item.name){
        cached_dependencies[item.name] = exp;
      }
      return true;
    }
    else {
      return;
    }
  }

  function wrapObj (o){
    if (typeof o === 'function'){
      return o;
    }
    else {
      return function (){
        return o;
      };
    }
  }

  function ad() {
    var item = {
        name:  typeof arguments[0] === 'string' ? arguments[0] : undefined,
        depNames: Array.isArray(arguments[0]) ? arguments[0] : Array.isArray(arguments[1]) ? arguments[1] : [],
        func: wrapObj(arguments[arguments.length - 1])
    };
    if (!execute(item)){
      queue.push(item);
    }
    else {
      if (item.name){
        runThroughQueue(); // executed straight away, try to resolve func that depends on this
      }
    }
  }
  cb.call(w, ad);
}(function (define) {
  if (typeof exports === 'object'){
  module.exports = define;
}
else{
  this.asyncDefine = define;
}

}));


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],9:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(29), __esModule: true };
});
},{"29":29,"8":8}],10:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(30), __esModule: true };
});
},{"30":30,"8":8}],11:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(31), __esModule: true };
});
},{"31":31,"8":8}],12:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(32), __esModule: true };
});
},{"32":32,"8":8}],13:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(33), __esModule: true };
});
},{"33":33,"8":8}],14:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(34), __esModule: true };
});
},{"34":34,"8":8}],15:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(35), __esModule: true };
});
},{"35":35,"8":8}],16:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(36), __esModule: true };
});
},{"36":36,"8":8}],17:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(37), __esModule: true };
});
},{"37":37,"8":8}],18:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(38), __esModule: true };
});
},{"38":38,"8":8}],19:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(39), __esModule: true };
});
},{"39":39,"8":8}],20:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(40), __esModule: true };
});
},{"40":40,"8":8}],21:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
});
},{"8":8}],22:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _defineProperty = require(14);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
});
},{"14":14,"8":8}],23:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require(17);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require(13);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require(26);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
});
},{"13":13,"17":17,"26":26,"8":8}],24:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _typeof2 = require(26);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
});
},{"26":26,"8":8}],25:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _isIterable2 = require(10);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require(9);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
});
},{"10":10,"8":8,"9":9}],26:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _iterator = require(20);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require(19);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
});
},{"19":19,"20":20,"8":8}],27:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(152);

});
},{"152":152,"8":8}],28:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){

});
},{"8":8}],29:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(128);
require(124);
module.exports = require(113);
});
},{"113":113,"124":124,"128":128,"8":8}],30:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(128);
require(124);
module.exports = require(114);
});
},{"114":114,"124":124,"128":128,"8":8}],31:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var core  = require(48)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};
});
},{"48":48,"8":8}],32:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(116);
module.exports = require(48).Object.assign;
});
},{"116":116,"48":48,"8":8}],33:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(117);
var $Object = require(48).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};
});
},{"117":117,"48":48,"8":8}],34:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(118);
var $Object = require(48).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};
});
},{"118":118,"48":48,"8":8}],35:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(119);
module.exports = require(48).Object.getPrototypeOf;
});
},{"119":119,"48":48,"8":8}],36:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(120);
module.exports = require(48).Object.keys;
});
},{"120":120,"48":48,"8":8}],37:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(121);
module.exports = require(48).Object.setPrototypeOf;
});
},{"121":121,"48":48,"8":8}],38:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(122);
require(124);
require(128);
require(123);
module.exports = require(48).Promise;
});
},{"122":122,"123":123,"124":124,"128":128,"48":48,"8":8}],39:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(125);
require(122);
require(126);
require(127);
module.exports = require(48).Symbol;
});
},{"122":122,"125":125,"126":126,"127":127,"48":48,"8":8}],40:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(124);
require(128);
module.exports = require(110).f('iterator');
});
},{"110":110,"124":124,"128":128,"8":8}],41:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};
});
},{"8":8}],42:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(){ /* empty */ };
});
},{"8":8}],43:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};
});
},{"8":8}],44:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var isObject = require(67);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};
});
},{"67":67,"8":8}],45:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require(104)
  , toLength  = require(105)
  , toIndex   = require(102);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};
});
},{"102":102,"104":104,"105":105,"8":8}],46:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require(47)
  , TAG = require(111)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};
});
},{"111":111,"47":47,"8":8}],47:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};
});
},{"8":8}],48:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
});
},{"8":8}],49:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// optional / simple context binding
var aFunction = require(41);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};
});
},{"41":41,"8":8}],50:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};
});
},{"8":8}],51:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// Thank's IE8 for his funny defineProperty
module.exports = !require(56)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});
});
},{"56":56,"8":8}],52:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var isObject = require(67)
  , document = require(58).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};
});
},{"58":58,"67":67,"8":8}],53:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');
});
},{"8":8}],54:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// all enumerable object keys, includes symbols
var getKeys = require(88)
  , gOPS    = require(85)
  , pIE     = require(89);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};
});
},{"8":8,"85":85,"88":88,"89":89}],55:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global    = require(58)
  , core      = require(48)
  , ctx       = require(49)
  , hide      = require(60)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
});
},{"48":48,"49":49,"58":58,"60":60,"8":8}],56:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};
});
},{"8":8}],57:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var ctx         = require(49)
  , call        = require(68)
  , isArrayIter = require(65)
  , anObject    = require(44)
  , toLength    = require(105)
  , getIterFn   = require(112)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;
});
},{"105":105,"112":112,"44":44,"49":49,"65":65,"68":68,"8":8}],58:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
});
},{"8":8}],59:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};
});
},{"8":8}],60:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var dP         = require(80)
  , createDesc = require(91);
module.exports = require(51) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};
});
},{"51":51,"8":8,"80":80,"91":91}],61:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(58).document && document.documentElement;
});
},{"58":58,"8":8}],62:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = !require(51) && !require(56)(function(){
  return Object.defineProperty(require(52)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});
});
},{"51":51,"52":52,"56":56,"8":8}],63:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};
});
},{"8":8}],64:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require(47);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};
});
},{"47":47,"8":8}],65:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// check on default Array iterator
var Iterators  = require(73)
  , ITERATOR   = require(111)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};
});
},{"111":111,"73":73,"8":8}],66:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.2.2 IsArray(argument)
var cof = require(47);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};
});
},{"47":47,"8":8}],67:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
});
},{"8":8}],68:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// call something on iterator step with safe closing on error
var anObject = require(44);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};
});
},{"44":44,"8":8}],69:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var create         = require(79)
  , descriptor     = require(91)
  , setToStringTag = require(96)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require(60)(IteratorPrototype, require(111)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};
});
},{"111":111,"60":60,"79":79,"8":8,"91":91,"96":96}],70:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var LIBRARY        = require(75)
  , $export        = require(55)
  , redefine       = require(93)
  , hide           = require(60)
  , has            = require(59)
  , Iterators      = require(73)
  , $iterCreate    = require(69)
  , setToStringTag = require(96)
  , getPrototypeOf = require(86)
  , ITERATOR       = require(111)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};
});
},{"111":111,"55":55,"59":59,"60":60,"69":69,"73":73,"75":75,"8":8,"86":86,"93":93,"96":96}],71:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var ITERATOR     = require(111)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};
});
},{"111":111,"8":8}],72:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(done, value){
  return {value: value, done: !!done};
};
});
},{"8":8}],73:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = {};
});
},{"8":8}],74:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var getKeys   = require(88)
  , toIObject = require(104);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};
});
},{"104":104,"8":8,"88":88}],75:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = true;
});
},{"8":8}],76:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var META     = require(108)('meta')
  , isObject = require(67)
  , has      = require(59)
  , setDesc  = require(80).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !require(56)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};
});
},{"108":108,"56":56,"59":59,"67":67,"8":8,"80":80}],77:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global    = require(58)
  , macrotask = require(101).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = require(47)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};
});
},{"101":101,"47":47,"58":58,"8":8}],78:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = require(88)
  , gOPS     = require(85)
  , pIE      = require(89)
  , toObject = require(106)
  , IObject  = require(64)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require(56)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;
});
},{"106":106,"56":56,"64":64,"8":8,"85":85,"88":88,"89":89}],79:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = require(44)
  , dPs         = require(81)
  , enumBugKeys = require(53)
  , IE_PROTO    = require(97)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require(52)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  require(61).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

});
},{"44":44,"52":52,"53":53,"61":61,"8":8,"81":81,"97":97}],80:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var anObject       = require(44)
  , IE8_DOM_DEFINE = require(62)
  , toPrimitive    = require(107)
  , dP             = Object.defineProperty;

exports.f = require(51) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};
});
},{"107":107,"44":44,"51":51,"62":62,"8":8}],81:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var dP       = require(80)
  , anObject = require(44)
  , getKeys  = require(88);

module.exports = require(51) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};
});
},{"44":44,"51":51,"8":8,"80":80,"88":88}],82:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var pIE            = require(89)
  , createDesc     = require(91)
  , toIObject      = require(104)
  , toPrimitive    = require(107)
  , has            = require(59)
  , IE8_DOM_DEFINE = require(62)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = require(51) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};
});
},{"104":104,"107":107,"51":51,"59":59,"62":62,"8":8,"89":89,"91":91}],83:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require(104)
  , gOPN      = require(84).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

});
},{"104":104,"8":8,"84":84}],84:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = require(87)
  , hiddenKeys = require(53).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};
});
},{"53":53,"8":8,"87":87}],85:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
exports.f = Object.getOwnPropertySymbols;
});
},{"8":8}],86:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = require(59)
  , toObject    = require(106)
  , IE_PROTO    = require(97)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};
});
},{"106":106,"59":59,"8":8,"97":97}],87:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var has          = require(59)
  , toIObject    = require(104)
  , arrayIndexOf = require(45)(false)
  , IE_PROTO     = require(97)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};
});
},{"104":104,"45":45,"59":59,"8":8,"97":97}],88:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = require(87)
  , enumBugKeys = require(53);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};
});
},{"53":53,"8":8,"87":87}],89:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
exports.f = {}.propertyIsEnumerable;
});
},{"8":8}],90:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// most Object methods by ES6 should accept primitives
var $export = require(55)
  , core    = require(48)
  , fails   = require(56);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};
});
},{"48":48,"55":55,"56":56,"8":8}],91:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};
});
},{"8":8}],92:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var hide = require(60);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};
});
},{"60":60,"8":8}],93:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(60);
});
},{"60":60,"8":8}],94:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require(67)
  , anObject = require(44);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = require(49)(Function.call, require(82).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};
});
},{"44":44,"49":49,"67":67,"8":8,"82":82}],95:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var global      = require(58)
  , core        = require(48)
  , dP          = require(80)
  , DESCRIPTORS = require(51)
  , SPECIES     = require(111)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};
});
},{"111":111,"48":48,"51":51,"58":58,"8":8,"80":80}],96:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var def = require(80).f
  , has = require(59)
  , TAG = require(111)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};
});
},{"111":111,"59":59,"8":8,"80":80}],97:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var shared = require(98)('keys')
  , uid    = require(108);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};
});
},{"108":108,"8":8,"98":98}],98:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global = require(58)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};
});
},{"58":58,"8":8}],99:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = require(44)
  , aFunction = require(41)
  , SPECIES   = require(111)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};
});
},{"111":111,"41":41,"44":44,"8":8}],100:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var toInteger = require(103)
  , defined   = require(50);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};
});
},{"103":103,"50":50,"8":8}],101:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var ctx                = require(49)
  , invoke             = require(63)
  , html               = require(61)
  , cel                = require(52)
  , global             = require(58)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(require(47)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};
});
},{"47":47,"49":49,"52":52,"58":58,"61":61,"63":63,"8":8}],102:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var toInteger = require(103)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};
});
},{"103":103,"8":8}],103:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};
});
},{"8":8}],104:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require(64)
  , defined = require(50);
module.exports = function(it){
  return IObject(defined(it));
};
});
},{"50":50,"64":64,"8":8}],105:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.15 ToLength
var toInteger = require(103)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};
});
},{"103":103,"8":8}],106:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.13 ToObject(argument)
var defined = require(50);
module.exports = function(it){
  return Object(defined(it));
};
});
},{"50":50,"8":8}],107:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require(67);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};
});
},{"67":67,"8":8}],108:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};
});
},{"8":8}],109:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global         = require(58)
  , core           = require(48)
  , LIBRARY        = require(75)
  , wksExt         = require(110)
  , defineProperty = require(80).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};
});
},{"110":110,"48":48,"58":58,"75":75,"8":8,"80":80}],110:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
exports.f = require(111);
});
},{"111":111,"8":8}],111:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var store      = require(98)('wks')
  , uid        = require(108)
  , Symbol     = require(58).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;
});
},{"108":108,"58":58,"8":8,"98":98}],112:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var classof   = require(46)
  , ITERATOR  = require(111)('iterator')
  , Iterators = require(73);
module.exports = require(48).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};
});
},{"111":111,"46":46,"48":48,"73":73,"8":8}],113:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var anObject = require(44)
  , get      = require(112);
module.exports = require(48).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};
});
},{"112":112,"44":44,"48":48,"8":8}],114:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var classof   = require(46)
  , ITERATOR  = require(111)('iterator')
  , Iterators = require(73);
module.exports = require(48).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};
});
},{"111":111,"46":46,"48":48,"73":73,"8":8}],115:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var addToUnscopables = require(42)
  , step             = require(72)
  , Iterators        = require(73)
  , toIObject        = require(104);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require(70)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
});
},{"104":104,"42":42,"70":70,"72":72,"73":73,"8":8}],116:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.3.1 Object.assign(target, source)
var $export = require(55);

$export($export.S + $export.F, 'Object', {assign: require(78)});
});
},{"55":55,"78":78,"8":8}],117:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var $export = require(55)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: require(79)});
});
},{"55":55,"79":79,"8":8}],118:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var $export = require(55);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require(51), 'Object', {defineProperty: require(80).f});
});
},{"51":51,"55":55,"8":8,"80":80}],119:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = require(106)
  , $getPrototypeOf = require(86);

require(90)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});
});
},{"106":106,"8":8,"86":86,"90":90}],120:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.14 Object.keys(O)
var toObject = require(106)
  , $keys    = require(88);

require(90)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});
});
},{"106":106,"8":8,"88":88,"90":90}],121:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require(55);
$export($export.S, 'Object', {setPrototypeOf: require(94).set});
});
},{"55":55,"8":8,"94":94}],122:[function(require,module,exports){
arguments[4][28][0].apply(exports,arguments)
},{"28":28,"8":8}],123:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var LIBRARY            = require(75)
  , global             = require(58)
  , ctx                = require(49)
  , classof            = require(46)
  , $export            = require(55)
  , isObject           = require(67)
  , aFunction          = require(41)
  , anInstance         = require(43)
  , forOf              = require(57)
  , speciesConstructor = require(99)
  , task               = require(101).set
  , microtask          = require(77)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[require(111)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require(92)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
require(96)($Promise, PROMISE);
require(95)(PROMISE);
Wrapper = require(48)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require(71)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});
});
},{"101":101,"111":111,"41":41,"43":43,"46":46,"48":48,"49":49,"55":55,"57":57,"58":58,"67":67,"71":71,"75":75,"77":77,"8":8,"92":92,"95":95,"96":96,"99":99}],124:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var $at  = require(100)(true);

// 21.1.3.27 String.prototype[@@iterator]()
require(70)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});
});
},{"100":100,"70":70,"8":8}],125:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
// ECMAScript 6 symbols shim
var global         = require(58)
  , has            = require(59)
  , DESCRIPTORS    = require(51)
  , $export        = require(55)
  , redefine       = require(93)
  , META           = require(76).KEY
  , $fails         = require(56)
  , shared         = require(98)
  , setToStringTag = require(96)
  , uid            = require(108)
  , wks            = require(111)
  , wksExt         = require(110)
  , wksDefine      = require(109)
  , keyOf          = require(74)
  , enumKeys       = require(54)
  , isArray        = require(66)
  , anObject       = require(44)
  , toIObject      = require(104)
  , toPrimitive    = require(107)
  , createDesc     = require(91)
  , _create        = require(79)
  , gOPNExt        = require(83)
  , $GOPD          = require(82)
  , $DP            = require(80)
  , $keys          = require(88)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  require(84).f = gOPNExt.f = $getOwnPropertyNames;
  require(89).f  = $propertyIsEnumerable;
  require(85).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !require(75)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require(60)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);
});
},{"104":104,"107":107,"108":108,"109":109,"110":110,"111":111,"44":44,"51":51,"54":54,"55":55,"56":56,"58":58,"59":59,"60":60,"66":66,"74":74,"75":75,"76":76,"79":79,"8":8,"80":80,"82":82,"83":83,"84":84,"85":85,"88":88,"89":89,"91":91,"93":93,"96":96,"98":98}],126:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(109)('asyncIterator');
});
},{"109":109,"8":8}],127:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(109)('observable');
});
},{"109":109,"8":8}],128:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(115);
var global        = require(58)
  , hide          = require(60)
  , Iterators     = require(73)
  , TO_STRING_TAG = require(111)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}
});
},{"111":111,"115":115,"58":58,"60":60,"73":73,"8":8}],129:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */

'use strict';

function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};

});
},{"8":8}],130:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
(function(global){

//
// Check for native Promise and it has correct interface
//

var NativePromise = global['Promise'];
var nativePromiseSupported =
  NativePromise &&
  // Some of these methods are missing from
  // Firefox/Chrome experimental implementations
  'resolve' in NativePromise &&
  'reject' in NativePromise &&
  'all' in NativePromise &&
  'race' in NativePromise &&
  // Older version of the spec had a resolver object
  // as the arg rather than a function
  (function(){
    var resolve;
    new NativePromise(function(r){ resolve = r; });
    return typeof resolve === 'function';
  })();


//
// export if necessary
//

if (typeof exports !== 'undefined' && exports)
{
  // node.js
  exports.Promise = nativePromiseSupported ? NativePromise : Promise;
  exports.Polyfill = Promise;
}
else
{
  // AMD
  if (typeof define == 'function' && define.amd)
  {
    define(function(){
      return nativePromiseSupported ? NativePromise : Promise;
    });
  }
  else
  {
    // in browser add to global
    if (!nativePromiseSupported)
      global['Promise'] = Promise;
  }
}


//
// Polyfill
//

var PENDING = 'pending';
var SEALED = 'sealed';
var FULFILLED = 'fulfilled';
var REJECTED = 'rejected';
var NOOP = function(){};

function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}

// async calls
var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
var asyncQueue = [];
var asyncTimer;

function asyncFlush(){
  // run promise callbacks
  for (var i = 0; i < asyncQueue.length; i++)
    asyncQueue[i][0](asyncQueue[i][1]);

  // reset async asyncQueue
  asyncQueue = [];
  asyncTimer = false;
}

function asyncCall(callback, arg){
  asyncQueue.push([callback, arg]);

  if (!asyncTimer)
  {
    asyncTimer = true;
    asyncSetTimer(asyncFlush, 0);
  }
}


function invokeResolver(resolver, promise) {
  function resolvePromise(value) {
    resolve(promise, value);
  }

  function rejectPromise(reason) {
    reject(promise, reason);
  }

  try {
    resolver(resolvePromise, rejectPromise);
  } catch(e) {
    rejectPromise(e);
  }
}

function invokeCallback(subscriber){
  var owner = subscriber.owner;
  var settled = owner.state_;
  var value = owner.data_;  
  var callback = subscriber[settled];
  var promise = subscriber.then;

  if (typeof callback === 'function')
  {
    settled = FULFILLED;
    try {
      value = callback(value);
    } catch(e) {
      reject(promise, e);
    }
  }

  if (!handleThenable(promise, value))
  {
    if (settled === FULFILLED)
      resolve(promise, value);

    if (settled === REJECTED)
      reject(promise, value);
  }
}

function handleThenable(promise, value) {
  var resolved;

  try {
    if (promise === value)
      throw new TypeError('A promises callback cannot return that same promise.');

    if (value && (typeof value === 'function' || typeof value === 'object'))
    {
      var then = value.then;  // then should be retrived only once

      if (typeof then === 'function')
      {
        then.call(value, function(val){
          if (!resolved)
          {
            resolved = true;

            if (value !== val)
              resolve(promise, val);
            else
              fulfill(promise, val);
          }
        }, function(reason){
          if (!resolved)
          {
            resolved = true;

            reject(promise, reason);
          }
        });

        return true;
      }
    }
  } catch (e) {
    if (!resolved)
      reject(promise, e);

    return true;
  }

  return false;
}

function resolve(promise, value){
  if (promise === value || !handleThenable(promise, value))
    fulfill(promise, value);
}

function fulfill(promise, value){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = value;

    asyncCall(publishFulfillment, promise);
  }
}

function reject(promise, reason){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = reason;

    asyncCall(publishRejection, promise);
  }
}

function publish(promise) {
  var callbacks = promise.then_;
  promise.then_ = undefined;

  for (var i = 0; i < callbacks.length; i++) {
    invokeCallback(callbacks[i]);
  }
}

function publishFulfillment(promise){
  promise.state_ = FULFILLED;
  publish(promise);
}

function publishRejection(promise){
  promise.state_ = REJECTED;
  publish(promise);
}

/**
* @class
*/
function Promise(resolver){
  if (typeof resolver !== 'function')
    throw new TypeError('Promise constructor takes a function argument');

  if (this instanceof Promise === false)
    throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');

  this.then_ = [];

  invokeResolver(resolver, this);
}

Promise.prototype = {
  constructor: Promise,

  state_: PENDING,
  then_: null,
  data_: undefined,

  then: function(onFulfillment, onRejection){
    var subscriber = {
      owner: this,
      then: new this.constructor(NOOP),
      fulfilled: onFulfillment,
      rejected: onRejection
    };

    if (this.state_ === FULFILLED || this.state_ === REJECTED)
    {
      // already resolved, call callback async
      asyncCall(invokeCallback, subscriber);
    }
    else
    {
      // subscribe
      this.then_.push(subscriber);
    }

    return subscriber.then;
  },

  'catch': function(onRejection) {
    return this.then(null, onRejection);
  }
};

Promise.all = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.all().');

  return new Class(function(resolve, reject){
    var results = [];
    var remaining = 0;

    function resolver(index){
      remaining++;
      return function(value){
        results[index] = value;
        if (!--remaining)
          resolve(results);
      };
    }

    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolver(i), reject);
      else
        results[i] = promise;
    }

    if (!remaining)
      resolve(results);
  });
};

Promise.race = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.race().');

  return new Class(function(resolve, reject) {
    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolve, reject);
      else
        resolve(promise);
    }
  });
};

Promise.resolve = function(value){
  var Class = this;

  if (value && typeof value === 'object' && value.constructor === Class)
    return value;

  return new Class(function(resolve){
    resolve(value);
  });
};

Promise.reject = function(reason){
  var Class = this;

  return new Class(function(resolve, reject){
    reject(reason);
  });
};

})(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : typeof self != 'undefined' ? self : this);

});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"8":8}],131:[function(require,module,exports){
(function (process,global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   3.3.1
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  return function () {
    vertxNext(flush);
  };
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = r('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

polyfill();
// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));

});
}).call(this,require(138),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"138":138,"8":8}],132:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*jslint es6, node, browser, maxlen: 120 */
/*global self, window */

"use strict";

module.exports = (function () {

    "use strict";

    var globalObject = undefined;

    function isFunction(x) {
        return typeof x === "function";
    }

    // Seek the global object
    if (global !== undefined) {
        globalObject = global;
    } else if (window !== undefined && window.document) {
        globalObject = window;
    } else {
        globalObject = self;
    }

    // Test for any native promise implementation, and if that
    // implementation appears to conform to the specificaton.
    // This code mostly nicked from the es6-promise module polyfill
    // and then fooled with.
    var hasPromiseSupport = (function () {

        // No promise object at all, and it's a non-starter
        if (!globalObject.hasOwnProperty("Promise")) {
            return false;
        }

        // There is a Promise object. Does it conform to the spec?
        var P = globalObject.Promise;

        // Some of these methods are missing from
        // Firefox/Chrome experimental implementations
        if (!P.hasOwnProperty("resolve") || !P.hasOwnProperty("reject")) {
            return false;
        }

        if (!P.hasOwnProperty("all") || !P.hasOwnProperty("race")) {
            return false;
        }

        // Older version of the spec had a resolver object
        // as the arg rather than a function
        return (function () {

            var resolve = undefined,
                p = new globalObject.Promise(function (r) {
                resolve = r;
            });

            if (p) {
                return isFunction(resolve);
            }

            return false;
        })();
    })();

    // Export the native Promise implementation if it
    // looks like it matches the spec
    if (hasPromiseSupport) {
        return globalObject.Promise;
    }

    //  Otherwise, return the es6-promise polyfill by @jaffathecake.
    return require(131).Promise;
})();
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"131":131,"8":8}],133:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*jslint node, this, es6, maxlen: 120 */
"use strict";

module.exports = (function () {

    "use strict";

    // Get a promise object. This may be native, or it may be polyfilled
    var ES6Promise = require(132);

    // Promise Context object constructor.
    function Context(resolve, reject, custom) {
        this.resolve = resolve;
        this.reject = reject;
        this.custom = custom;
    }

    // Default callback function - rejects on truthy error, otherwise resolves
    function callback() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var ctx = args.shift(),
            err = args.shift(),
            cust = undefined;

        args = args.length > 1 ? args : args[0];

        if (typeof ctx.custom === 'function') {
            cust = function () {
                for (var _len2 = arguments.length, custArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    custArgs[_key2] = arguments[_key2];
                }

                // Bind the callback to itself, so the resolve and reject
                // properties that we bound are available to the callback.
                // Then we push it onto the end of the arguments array.
                return ctx.custom.apply(cust, custArgs);
            };
            cust.resolve = ctx.resolve;
            cust.reject = ctx.reject;
            cust.call(null, err, args);
        } else {
            if (err) {
                return ctx.reject(err);
            }
            ctx.resolve(args);
        }
    }

    /**
     * promisify
     *
     * Transforms callback-based function -- func(arg1, arg2 .. argN, callback) -- into
     * an ES6-compatible Promise. User can provide their own callback function; otherwise
     * promisify provides a callback of the form (error, result) and rejects on truthy error.
     * If supplying your own callback function, use this.resolve() and this.reject().
     *
     * @param {function} original - The function to promisify
     * @param {function} callback - Optional custom callbac function
     *
     * @return {function} A promisified version of 'original'
     */
    return function (original, custom) {

        return function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            // Store original context
            var that = this;

            // Return the promisified function
            return new ES6Promise(function (resolve, reject) {

                // Create a Context object
                var ctx = new Context(resolve, reject, custom);

                // Append the callback bound to the context
                args.push(callback.bind(null, ctx));

                // Call the function
                original.apply(that, args);
            });
        };
    };
})();
});
},{"132":132,"8":8}],134:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
(function() {
	var testObject = {};

	if (!(Object.setPrototypeOf || testObject.__proto__)) {
		var nativeGetPrototypeOf = Object.getPrototypeOf;

		Object.getPrototypeOf = function(object) {
			if (object.__proto__) {
				return object.__proto__;
			} else {
				return nativeGetPrototypeOf.call(Object, object);
			}
		}
	}
})();

});
},{"8":8}],135:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

/**
 * Expose `md5omatic(str)`.
 */
 
module.exports = md5omatic;

/**
 * Hash any string using message digest.
 *
 * @param {String} str
 * @return {String}
 * @api public
 */
 
function md5omatic(str) {
    var x = str2blks_MD5(str);
    var a =  1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d =  271733878;

    for(var i=0; i<x.length; i += 16)
    {
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;

        a = ff(a, b, c, d, x[i+ 0], 7 , -680876936);
        d = ff(d, a, b, c, x[i+ 1], 12, -389564586);
        c = ff(c, d, a, b, x[i+ 2], 17,  606105819);
        b = ff(b, c, d, a, x[i+ 3], 22, -1044525330);
        a = ff(a, b, c, d, x[i+ 4], 7 , -176418897);
        d = ff(d, a, b, c, x[i+ 5], 12,  1200080426);
        c = ff(c, d, a, b, x[i+ 6], 17, -1473231341);
        b = ff(b, c, d, a, x[i+ 7], 22, -45705983);
        a = ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
        d = ff(d, a, b, c, x[i+ 9], 12, -1958414417);
        c = ff(c, d, a, b, x[i+10], 17, -42063);
        b = ff(b, c, d, a, x[i+11], 22, -1990404162);
        a = ff(a, b, c, d, x[i+12], 7 ,  1804603682);
        d = ff(d, a, b, c, x[i+13], 12, -40341101);
        c = ff(c, d, a, b, x[i+14], 17, -1502002290);
        b = ff(b, c, d, a, x[i+15], 22,  1236535329);
        a = gg(a, b, c, d, x[i+ 1], 5 , -165796510);
        d = gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
        c = gg(c, d, a, b, x[i+11], 14,  643717713);
        b = gg(b, c, d, a, x[i+ 0], 20, -373897302);
        a = gg(a, b, c, d, x[i+ 5], 5 , -701558691);
        d = gg(d, a, b, c, x[i+10], 9 ,  38016083);
        c = gg(c, d, a, b, x[i+15], 14, -660478335);
        b = gg(b, c, d, a, x[i+ 4], 20, -405537848);
        a = gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
        d = gg(d, a, b, c, x[i+14], 9 , -1019803690);
        c = gg(c, d, a, b, x[i+ 3], 14, -187363961);
        b = gg(b, c, d, a, x[i+ 8], 20,  1163531501);
        a = gg(a, b, c, d, x[i+13], 5 , -1444681467);
        d = gg(d, a, b, c, x[i+ 2], 9 , -51403784);
        c = gg(c, d, a, b, x[i+ 7], 14,  1735328473);
        b = gg(b, c, d, a, x[i+12], 20, -1926607734);
        a = hh(a, b, c, d, x[i+ 5], 4 , -378558);
        d = hh(d, a, b, c, x[i+ 8], 11, -2022574463);
        c = hh(c, d, a, b, x[i+11], 16,  1839030562);
        b = hh(b, c, d, a, x[i+14], 23, -35309556);
        a = hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
        d = hh(d, a, b, c, x[i+ 4], 11,  1272893353);
        c = hh(c, d, a, b, x[i+ 7], 16, -155497632);
        b = hh(b, c, d, a, x[i+10], 23, -1094730640);
        a = hh(a, b, c, d, x[i+13], 4 ,  681279174);
        d = hh(d, a, b, c, x[i+ 0], 11, -358537222);
        c = hh(c, d, a, b, x[i+ 3], 16, -722521979);
        b = hh(b, c, d, a, x[i+ 6], 23,  76029189);
        a = hh(a, b, c, d, x[i+ 9], 4 , -640364487);
        d = hh(d, a, b, c, x[i+12], 11, -421815835);
        c = hh(c, d, a, b, x[i+15], 16,  530742520);
        b = hh(b, c, d, a, x[i+ 2], 23, -995338651);
        a = ii(a, b, c, d, x[i+ 0], 6 , -198630844);
        d = ii(d, a, b, c, x[i+ 7], 10,  1126891415);
        c = ii(c, d, a, b, x[i+14], 15, -1416354905);
        b = ii(b, c, d, a, x[i+ 5], 21, -57434055);
        a = ii(a, b, c, d, x[i+12], 6 ,  1700485571);
        d = ii(d, a, b, c, x[i+ 3], 10, -1894986606);
        c = ii(c, d, a, b, x[i+10], 15, -1051523);
        b = ii(b, c, d, a, x[i+ 1], 21, -2054922799);
        a = ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
        d = ii(d, a, b, c, x[i+15], 10, -30611744);
        c = ii(c, d, a, b, x[i+ 6], 15, -1560198380);
        b = ii(b, c, d, a, x[i+13], 21,  1309151649);
        a = ii(a, b, c, d, x[i+ 4], 6 , -145523070);
        d = ii(d, a, b, c, x[i+11], 10, -1120210379);
        c = ii(c, d, a, b, x[i+ 2], 15,  718787259);
        b = ii(b, c, d, a, x[i+ 9], 21, -343485551);

        a = addme(a, olda);
        b = addme(b, oldb);
        c = addme(c, oldc);
        d = addme(d, oldd);
    }

    return rhex(a) + rhex(b) + rhex(c) + rhex(d);
};

var hex_chr = "0123456789abcdef";

function bitOR(a, b)
{
    var lsb = (a & 0x1) | (b & 0x1);
    var msb31 = (a >>> 1) | (b >>> 1);

    return (msb31 << 1) | lsb;
}

function bitXOR(a, b)
{
    var lsb = (a & 0x1) ^ (b & 0x1);
    var msb31 = (a >>> 1) ^ (b >>> 1);

    return (msb31 << 1) | lsb;
}

function bitAND(a, b)
{
    var lsb = (a & 0x1) & (b & 0x1);
    var msb31 = (a >>> 1) & (b >>> 1);

    return (msb31 << 1) | lsb;
}

function addme(x, y)
{
    var lsw = (x & 0xFFFF)+(y & 0xFFFF);
    var msw = (x >> 16)+(y >> 16)+(lsw >> 16);

    return (msw << 16) | (lsw & 0xFFFF);
}

function rhex(num)
{
    var str = "";
    var j;

    for(j=0; j<=3; j++)
        str += hex_chr.charAt((num >> (j * 8 + 4)) & 0x0F) + hex_chr.charAt((num >> (j * 8)) & 0x0F);

    return str;
}

function str2blks_MD5(str)
{
    var nblk = ((str.length + 8) >> 6) + 1;
    var blks = new Array(nblk * 16);
    var i;

    for(i=0; i<nblk * 16; i++)
        blks[i] = 0;

    for(i=0; i<str.length; i++)
        blks[i >> 2] |= str.charCodeAt(i) << (((str.length * 8 + i) % 4) * 8);

    blks[i >> 2] |= 0x80 << (((str.length * 8 + i) % 4) * 8);

    var l = str.length * 8;
    blks[nblk * 16 - 2] = (l & 0xFF);
    blks[nblk * 16 - 2] |= ((l >>> 8) & 0xFF) << 8;
    blks[nblk * 16 - 2] |= ((l >>> 16) & 0xFF) << 16;
    blks[nblk * 16 - 2] |= ((l >>> 24) & 0xFF) << 24;

    return blks;
}

function rol(num, cnt)
{
    return (num << cnt) | (num >>> (32 - cnt));
}

function cmn(q, a, b, x, s, t)
{
    return addme(rol((addme(addme(a, q), addme(x, t))), s), b);
}

function ff(a, b, c, d, x, s, t)
{
    return cmn(bitOR(bitAND(b, c), bitAND((~b), d)), a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t)
{
    return cmn(bitOR(bitAND(b, d), bitAND(c, (~d))), a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t)
{
    return cmn(bitXOR(bitXOR(b, c), d), a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t)
{
    return cmn(bitXOR(c, bitOR(b, (~d))), a, b, x, s, t);
}
});
},{"8":8}],136:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var md5omatic = require(135);

module.exports = function (func, prefix) {
  prefix = prefix || '';
  func = func || function () { return '_default'; };
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var k = func.apply(undefined, args);
    if (k === null) {
      return null;
    }
    if (typeof k === 'undefined' ||
      (typeof k === 'number' && isNaN(k)) ||
      k === '' ||
      (typeof k === 'object' && Object.keys(k).length === 0)) {
      throw new Error('Not a valid key');
    }
    if (typeof k !== 'string') {
      k = md5omatic(JSON.stringify(k));
    }
    return prefix + k;
  };
};

});
},{"135":135,"8":8}],137:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
function isObj(v) {
  return typeof v === 'object';
}

function isStr(v) {
  return typeof v === 'string';
}

function isBool(v) {
  return typeof v === 'boolean';
}

function isUndef(v) {
  if (typeof v === 'string') {
    return v.length === 0;
  }
  return typeof v === 'undefined';
}

function flatten(arr) {
  return [].concat.apply([], arr);
}

var emailRE = /.+\@.+\..+/;

var _validatorFactories = {
  object: function () { return function (value) { return (isUndef(value) || isObj(value) ? [] : ['object.base']); }; },
  string: function () { return function (value) { return (isUndef(value) || isStr(value) ? [] : ['string.base']); }; },
  boolean: function () { return function (value) { return (isUndef(value) || isBool(value) ? [] : ['boolean.base']); }; },
  min: function (minValue) { return function (value) { return (isUndef(value) || value.length >= minValue ? [] : ['string.min']); }; },
  max: function (maxValue) { return function (value) { return (isUndef(value) || value.length <= maxValue ? [] : ['string.max']); }; },
  email: function () { return function (value) { return (isUndef(value) || emailRE.test(value) ? [] : ['string.email']); }; },
  required: function () { return function (value) { return (!isUndef(value) ? [] : ['any.empty']); }; },
  regex: function (re) { return function (value) { return (isUndef(value) || re.test(value) ? [] : ['string.regex.base']); }; },
  keys: function (obj) { return function (value) { return (isUndef(value) ? [] : flatten(Object.keys(obj).map(function (attr) { return obj[attr]._validate(value[attr], attr); }))); }; },
};

function _joi() {
  this._validators = [];
}

var joi = {};

Object.keys(_validatorFactories).forEach(function (k) {
  _joi.prototype[k] = function unnamed(arg) {
    this._validators.push(_validatorFactories[k](arg));
    return this;
  };

  joi[k] = function (arg) {
    var j = new _joi();
    return j[k](arg);
  };
});

_joi.prototype._validate = function _validate(value, path) {
  return flatten(this._validators.map(function (func) { return func(value); }))
  .map(function (e) {
    var out = {
      type: typeof e === 'string' ? e : e.type,
    };
    var paths = [];
    if (path) {
      paths.push(path);
    }
    if (typeof e !== 'string' && 'path' in e) {
      paths.push(e.path);
    }

    if (paths.length) {
      out.path = paths.join('.');
    }
    return out;
  });
};

joi.validate = function validate(data, schema, options, callback) {
  // const abortEarly = options.abortEarly;
  var errors = schema._validate(data);
  var out = errors.length ? {
    error: {
      details: errors,
    },
    value: data,
  } : { error: null, value: data };

  if (callback) {
    callback(out.error, out.value);
  }
  return out;
};

module.exports = joi;

});
},{"8":8}],138:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

});
},{"8":8}],139:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(140)
});
},{"140":140,"8":8}],140:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _io = require(145);

Object.defineProperty(exports, 'take', {
  enumerable: true,
  get: function get() {
    return _io.take;
  }
});
Object.defineProperty(exports, 'takem', {
  enumerable: true,
  get: function get() {
    return _io.takem;
  }
});
Object.defineProperty(exports, 'put', {
  enumerable: true,
  get: function get() {
    return _io.put;
  }
});
Object.defineProperty(exports, 'race', {
  enumerable: true,
  get: function get() {
    return _io.race;
  }
});
Object.defineProperty(exports, 'call', {
  enumerable: true,
  get: function get() {
    return _io.call;
  }
});
Object.defineProperty(exports, 'apply', {
  enumerable: true,
  get: function get() {
    return _io.apply;
  }
});
Object.defineProperty(exports, 'cps', {
  enumerable: true,
  get: function get() {
    return _io.cps;
  }
});
Object.defineProperty(exports, 'fork', {
  enumerable: true,
  get: function get() {
    return _io.fork;
  }
});
Object.defineProperty(exports, 'spawn', {
  enumerable: true,
  get: function get() {
    return _io.spawn;
  }
});
Object.defineProperty(exports, 'join', {
  enumerable: true,
  get: function get() {
    return _io.join;
  }
});
Object.defineProperty(exports, 'cancel', {
  enumerable: true,
  get: function get() {
    return _io.cancel;
  }
});
Object.defineProperty(exports, 'select', {
  enumerable: true,
  get: function get() {
    return _io.select;
  }
});
Object.defineProperty(exports, 'actionChannel', {
  enumerable: true,
  get: function get() {
    return _io.actionChannel;
  }
});
Object.defineProperty(exports, 'cancelled', {
  enumerable: true,
  get: function get() {
    return _io.cancelled;
  }
});
Object.defineProperty(exports, 'flush', {
  enumerable: true,
  get: function get() {
    return _io.flush;
  }
});
});
},{"145":145,"8":8}],141:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;

var _runSaga = require(148);

Object.defineProperty(exports, 'runSaga', {
  enumerable: true,
  get: function get() {
    return _runSaga.runSaga;
  }
});

var _channel = require(144);

Object.defineProperty(exports, 'END', {
  enumerable: true,
  get: function get() {
    return _channel.END;
  }
});
Object.defineProperty(exports, 'eventChannel', {
  enumerable: true,
  get: function get() {
    return _channel.eventChannel;
  }
});
Object.defineProperty(exports, 'channel', {
  enumerable: true,
  get: function get() {
    return _channel.channel;
  }
});

var _buffers = require(143);

Object.defineProperty(exports, 'buffers', {
  enumerable: true,
  get: function get() {
    return _buffers.buffers;
  }
});

var _sagaHelpers = require(149);

Object.defineProperty(exports, 'takeEvery', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.takeEvery;
  }
});
Object.defineProperty(exports, 'takeLatest', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.takeLatest;
  }
});
Object.defineProperty(exports, 'throttle', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.throttle;
  }
});

var _utils = require(150);

Object.defineProperty(exports, 'delay', {
  enumerable: true,
  get: function get() {
    return _utils.delay;
  }
});
Object.defineProperty(exports, 'CANCEL', {
  enumerable: true,
  get: function get() {
    return _utils.CANCEL;
  }
});

var _middleware = require(146);

var _middleware2 = _interopRequireDefault(_middleware);

var _effects = require(140);

var effects = _interopRequireWildcard(_effects);

var _utils2 = require(151);

var utils = _interopRequireWildcard(_utils2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _middleware2.default;
exports.effects = effects;
exports.utils = utils;
});
},{"140":140,"143":143,"144":144,"146":146,"148":148,"149":149,"150":150,"151":151,"8":8}],142:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = asap;
var queue = [];
var isSuspended = false;

function asap(task) {
  if (!isSuspended) {
    isSuspended = true;
    queue.push(task);
    asap.flush();
  } else {
    queue.push(task);
  }
}

asap.suspend = function () {
  return isSuspended = true;
};
asap.flush = function () {
  var nextTask = void 0;
  while (nextTask = queue.shift()) {
    nextTask();
  }
  isSuspended = false;
};
});
},{"8":8}],143:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buffers = exports.BUFFER_OVERFLOW = undefined;

var _utils = require(150);

var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };

function ringBuffer() {
  var limit = arguments.length <= 0 || arguments[0] === undefined ? 10 : arguments[0];
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take, flush: flush
  };
}

var buffers = exports.buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};
});
},{"150":150,"8":8}],144:[function(require,module,exports){
(function (process){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.emitter = emitter;
exports.channel = channel;
exports.eventChannel = eventChannel;
exports.stdChannel = stdChannel;

var _utils = require(150);

var _buffers = require(143);

var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = exports.END = { type: CHANNEL_END_TYPE };
var isEnd = exports.isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return (0, _utils.remove)(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (process.env.NODE_ENV !== 'production') {
  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length <= 0 || arguments[0] === undefined ? _buffers.buffers.fixed() : arguments[0];

  var closed = false;
  var takers = [];

  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    (0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return (0, _utils.remove)(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return { take: take, put: put, flush: flush, close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length <= 1 || arguments[1] === undefined ? _buffers.buffers.none() : arguments[1];
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      chan.close();
    } else if (!matcher || matcher(input)) {
      chan.put(input);
    }
  });

  if (!_utils.is.func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: function close() {
      if (!chan.__closed__) {
        chan.close();
        unsubscribe();
      }
    }
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(subscribe);

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
        cb[_utils.MATCH] = matcher;
      }
      chan.take(cb);
    }
  });
}
});
}).call(this,require(138))

},{"138":138,"143":143,"150":150,"8":8}],145:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asEffect = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.take = take;
exports.takem = takem;
exports.put = put;
exports.race = race;
exports.call = call;
exports.apply = apply;
exports.cps = cps;
exports.fork = fork;
exports.spawn = spawn;
exports.join = join;
exports.cancel = cancel;
exports.select = select;
exports.actionChannel = actionChannel;
exports.cancelled = cancelled;
exports.flush = flush;

var _utils = require(150);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IO = (0, _utils.sym)('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;
};

function take() {
  var patternOrChannel = arguments.length <= 0 || arguments[0] === undefined ? '*' : arguments[0];

  if (arguments.length) {
    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (_utils.is.pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (_utils.is.channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

function takem() {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
}

function put(channel, action) {
  if (arguments.length > 1) {
    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
  } else {
    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.sync = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].sync = true;
  return eff;
};

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (_utils.is.array(fn)) {
    var _fn = fn;

    var _fn2 = _slicedToArray(_fn, 2);

    context = _fn2[0];
    fn = _fn2[1];
  } else if (fn.fn) {
    var _fn3 = fn;
    context = _fn3.context;
    fn = _fn3.fn;
  }
  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  var eff = fork.apply(undefined, [fn].concat(args));
  eff[FORK].detached = true;
  return eff;
}

var isForkedTask = function isForkedTask(task) {
  return task[_utils.TASK];
};

function join(task) {
  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
  if (!isForkedTask(task)) {
    throw new Error('join(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
  }

  return effect(JOIN, task);
}

function cancel(task) {
  (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
  if (!isForkedTask(task)) {
    throw new Error('cancel(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
  }

  return effect(CANCEL, task);
}

function select(selector) {
  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (arguments.length === 0) {
    selector = _utils.ident;
  } else {
    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

var asEffect = exports.asEffect = {
  take: function take(effect) {
    return effect && effect[IO] && effect[TAKE];
  },
  put: function put(effect) {
    return effect && effect[IO] && effect[PUT];
  },
  race: function race(effect) {
    return effect && effect[IO] && effect[RACE];
  },
  call: function call(effect) {
    return effect && effect[IO] && effect[CALL];
  },
  cps: function cps(effect) {
    return effect && effect[IO] && effect[CPS];
  },
  fork: function fork(effect) {
    return effect && effect[IO] && effect[FORK];
  },
  join: function join(effect) {
    return effect && effect[IO] && effect[JOIN];
  },
  cancel: function cancel(effect) {
    return effect && effect[IO] && effect[CANCEL];
  },
  select: function select(effect) {
    return effect && effect[IO] && effect[SELECT];
  },
  actionChannel: function actionChannel(effect) {
    return effect && effect[IO] && effect[ACTION_CHANNEL];
  },
  cancelled: function cancelled(effect) {
    return effect && effect[IO] && effect[CANCELLED];
  },
  flush: function flush(effect) {
    return effect && effect[IO] && effect[FLUSH];
  }
};
});
},{"150":150,"8":8}],146:[function(require,module,exports){
(function (process){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sagaMiddlewareFactory;

var _utils = require(150);

var _proc = require(147);

var _proc2 = _interopRequireDefault(_proc);

var _channel = require(144);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sagaMiddlewareFactory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var runSagaDynamically = void 0;

  if (_utils.is.func(options)) {
    if (process.env.NODE_ENV === 'production') {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (options.logger && !_utils.is.func(options.logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (options.onerror && !_utils.is.func(options.onerror)) {
    throw new Error('`options.onerror` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref) {
    var getState = _ref.getState;
    var dispatch = _ref.dispatch;

    runSagaDynamically = runSaga;
    var sagaEmitter = (0, _channel.emitter)();

    function runSaga(saga) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (0, _proc2.default)(saga.apply(undefined, args), sagaEmitter.subscribe, dispatch, getState, options, 0, saga.name);
    }

    return function (next) {
      return function (action) {
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function (saga) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');
    return runSagaDynamically.apply(undefined, [saga].concat(args));
  };

  return sagaMiddleware;
}
});
}).call(this,require(138))

},{"138":138,"144":144,"147":147,"150":150,"8":8}],147:[function(require,module,exports){
(function (process){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
exports.default = proc;

var _utils = require(150);

var _asap = require(142);

var _asap2 = _interopRequireDefault(_asap);

var _io = require(145);

var _channel = require(144);

var _buffers = require(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isDev = process.env.NODE_ENV === 'development';

var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var nextEffectId = (0, _utils.autoInc)();
var CHANNEL_END = exports.CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = exports.TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return _utils.kTrue;
  },
  default: function _default(pattern) {
    return function (input) {
      return input.type === pattern;
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return p === input.type;
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes iff all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      (0, _utils.remove)(tasks, task);
      task.cont = _utils.noop;
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = _utils.noop;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context;
  var fn = _ref.fn;
  var args = _ref.args;

  if (_utils.is.iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (_utils.is.iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? (0, _utils.makeIterator)(function () {
    throw error;
  }) : (0, _utils.makeIterator)(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

function wrapHelper(helper) {
  return {
    fn: helper
  };
}

function proc(iterator) {
  var subscribe = arguments.length <= 1 || arguments[1] === undefined ? function () {
    return _utils.noop;
  } : arguments[1];
  var dispatch = arguments.length <= 2 || arguments[2] === undefined ? _utils.noop : arguments[2];
  var getState = arguments.length <= 3 || arguments[3] === undefined ? _utils.noop : arguments[3];
  var options = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
  var parentEffectId = arguments.length <= 5 || arguments[5] === undefined ? 0 : arguments[5];
  var name = arguments.length <= 6 || arguments[6] === undefined ? 'anonymous' : arguments[6];
  var cont = arguments[7];

  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);

  var sagaMonitor = options.sagaMonitor;
  var logger = options.logger;
  var onError = options.onError;

  var log = logger || _utils.log;
  var stdChannel = (0, _channel.stdChannel)(subscribe);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = _utils.noop;

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL autoamtically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          Thill will jump to the finally block
        **/
        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        log('error', 'uncaught at ' + name, error.message);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      if (result === TASK_CANCEL && isDev) {
        log('info', name + ' has been cancelled', '');
      }
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
      }
      if (!task.cont) {
        log('error', 'uncaught', result.sagaStack || result.stack);
        if (result instanceof Error && onError) {
          onError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
    var cb = arguments[3];

    var effectId = nextEffectId();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = _utils.noop; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }

      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = _utils.noop;

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        log('error', 'uncaught at ' + name, err.message);
      }
      currCb.cancel = _utils.noop; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    return (
      // Non declarative effect
      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[_utils.CANCEL];
    if (typeof cancelPromise === 'function') {
      cb.cancel = cancelPromise;
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel;
    var pattern = _ref2.pattern;
    var maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel;
    var action = _ref3.action;
    var sync = _ref3.sync;

    /*
      Use a reentrant lock `asap` to flatten all nested dispatches
      If this put cause another Saga to take this action an then immediately
      put an action that will be taken by this Saga. Then the outer Saga will miss
      the action from the inner Saga b/c this put has not yet returned.
    */
    (0, _asap2.default)(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.sync` was used then bubble up the error.
        if (channel || sync) return cb(error, true);
        log('error', 'uncaught at ' + name, error.stack || error.message || error);
      }

      if (sync && _utils.is.promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context;
    var fn = _ref4.fn;
    var args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context;
    var fn = _ref5.fn;
    var args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      (function () {
        var cpsCb = function cpsCb(err, res) {
          return _utils.is.undef(err) ? cb(res) : cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) {
          cb.cancel = function () {
            return cpsCb.cancel();
          };
        }
      })();
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context;
    var fn = _ref6.fn;
    var args = _ref6.args;
    var detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    _asap2.default.suspend();
    var task = proc(taskIterator, subscribe, dispatch, getState, options, effectId, fn.name, detached ? null : _utils.noop);

    if (detached) {
      cb(task);
    } else {
      if (taskIterator._isRunning) {
        taskQueue.addTask(task);
        cb(task);
      } else if (taskIterator._error) {
        taskQueue.abort(taskIterator._error);
      } else {
        cb(task);
      }
    }
    _asap2.default.flush();
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      (function () {
        var joiner = { task: task, cb: cb };
        cb.cancel = function () {
          return (0, _utils.remove)(t.joiners, joiner);
        };
        t.joiners.push(joiner);
      })();
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(task, cb) {
    if (task.isRunning()) {
      task.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runParallelEffect(effects, effectId, cb) {
    if (!effects.length) {
      return cb([]);
    }

    var completedCount = 0;
    var completed = void 0;
    var results = Array(effects.length);

    function checkEffectEnd() {
      if (completedCount === results.length) {
        completed = true;
        cb(results);
      }
    }

    var childCbs = effects.map(function (eff, idx) {
      var chCbAtIdx = function chCbAtIdx(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[idx] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtIdx.cancel = _utils.noop;
      return chCbAtIdx;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        childCbs.forEach(function (chCb) {
          return chCb.cancel();
        });
      }
    };

    effects.forEach(function (eff, idx) {
      return runEffect(eff, effectId, idx, childCbs[idx]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          cb.cancel();
          completed = true;
          cb(_defineProperty({}, key, res));
        }
      };
      chCbAtKey.cancel = _utils.noop;
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector;
    var args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern;
    var buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _defineProperty(_ref9, _utils.TASK, true), _defineProperty(_ref9, 'id', id), _defineProperty(_ref9, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = (0, _utils.deferred)();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _defineProperty(_ref9, 'cont', cont), _defineProperty(_ref9, 'joiners', []), _defineProperty(_ref9, 'cancel', cancel), _defineProperty(_ref9, 'isRunning', function isRunning() {
      return iterator._isRunning;
    }), _defineProperty(_ref9, 'isCancelled', function isCancelled() {
      return iterator._isCancelled;
    }), _defineProperty(_ref9, 'isAborted', function isAborted() {
      return iterator._isAborted;
    }), _defineProperty(_ref9, 'result', function result() {
      return iterator._result;
    }), _defineProperty(_ref9, 'error', function error() {
      return iterator._error;
    }), _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}
});
}).call(this,require(138))

},{"138":138,"142":142,"143":143,"144":144,"145":145,"150":150,"8":8}],148:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runSaga = runSaga;

var _utils = require(150);

var _proc = require(147);

var _proc2 = _interopRequireDefault(_proc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function runSaga(iterator, _ref) {
  var subscribe = _ref.subscribe;
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;
  var sagaMonitor = _ref.sagaMonitor;
  var logger = _ref.logger;


  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");

  return (0, _proc2.default)(iterator, subscribe, dispatch, getState, { sagaMonitor: sagaMonitor, logger: logger });
}
});
},{"147":147,"150":150,"8":8}],149:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.takeEvery = takeEvery;
exports.takeLatest = takeLatest;
exports.throttle = throttle;

var _channel = require(144);

var _utils = require(150);

var _io = require(145);

var _buffers = require(143);

var done = { done: true, value: undefined };
var qEnd = {};

function fsmIterator(fsm, q0) {
  var name = arguments.length <= 2 || arguments[2] === undefined ? 'iterator' : arguments[2];

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext]();

      var _fsm$qNext2 = _slicedToArray(_fsm$qNext, 3);

      var q = _fsm$qNext2[0];
      var output = _fsm$qNext2[1];
      var _updateState = _fsm$qNext2[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return (0, _utils.makeIterator)(next, function (error) {
    return next(null, error);
  }, name, true);
}

function safeName(pattern) {
  if (Array.isArray(pattern)) {
    return String(pattern.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(pattern);
  }
}

function takeEvery(pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: (0, _io.take)(pattern) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [qEnd] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + safeName(pattern) + ', ' + worker.name + ')');
}

function takeLatest(pattern, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  var yTake = { done: false, value: (0, _io.take)(pattern) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: (0, _io.cancel)(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + safeName(pattern) + ', ' + worker.name + ')');
}

function throttle(delayLength, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: (0, _io.take)(channel, pattern) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
}
});
},{"143":143,"144":144,"145":145,"150":150,"8":8}],150:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.check = check;
exports.remove = remove;
exports.deferred = deferred;
exports.arrayOfDeffered = arrayOfDeffered;
exports.delay = delay;
exports.createMockTask = createMockTask;
exports.autoInc = autoInc;
exports.makeIterator = makeIterator;
exports.log = log;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sym = exports.sym = function sym(id) {
  return '@@redux-saga/' + id;
};
var TASK = exports.TASK = sym('TASK');
var HELPER = exports.HELPER = sym('HELPER');
var MATCH = exports.MATCH = sym('MATCH');
var CANCEL = exports.CANCEL = sym('cancelPromise');
var konst = exports.konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = exports.kTrue = konst(true);
var kFalse = exports.kFalse = konst(false);
var noop = exports.noop = function noop() {};
var ident = exports.ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var is = exports.is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  array: Array.isArray,
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (typeof pat === 'string' || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

function deferred() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
    return running;
  }), _defineProperty(_ref, 'result', function result() {
    return _result;
  }), _defineProperty(_ref, 'error', function error() {
    return _error;
  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
    return running = b;
  }), _defineProperty(_ref, 'setResult', function setResult(r) {
    return _result = r;
  }), _defineProperty(_ref, 'setError', function setError(e) {
    return _error = e;
  }), _ref;
}

function autoInc() {
  var seed = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

  return function () {
    return ++seed;
  };
}

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length <= 1 || arguments[1] === undefined ? kThrow : arguments[1];
  var name = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message, error) {
  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

var internalErr = exports.internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};
});
},{"8":8}],151:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require(150);

Object.defineProperty(exports, 'TASK', {
  enumerable: true,
  get: function get() {
    return _utils.TASK;
  }
});
Object.defineProperty(exports, 'noop', {
  enumerable: true,
  get: function get() {
    return _utils.noop;
  }
});
Object.defineProperty(exports, 'is', {
  enumerable: true,
  get: function get() {
    return _utils.is;
  }
});
Object.defineProperty(exports, 'deferred', {
  enumerable: true,
  get: function get() {
    return _utils.deferred;
  }
});
Object.defineProperty(exports, 'arrayOfDeffered', {
  enumerable: true,
  get: function get() {
    return _utils.arrayOfDeffered;
  }
});
Object.defineProperty(exports, 'createMockTask', {
  enumerable: true,
  get: function get() {
    return _utils.createMockTask;
  }
});

var _io = require(145);

Object.defineProperty(exports, 'asEffect', {
  enumerable: true,
  get: function get() {
    return _io.asEffect;
  }
});
});
},{"145":145,"150":150,"8":8}],152:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require(153);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"153":153,"8":8}],153:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"8":8}],154:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*!
  * Reqwest! A general purpose XHR connection manager
  * license MIT (c) Dustin Diaz 2015
  * https://github.com/ded/reqwest
  */

!function (name, context, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (typeof define == 'function' && define.amd) define(definition)
  else context[name] = definition()
}('reqwest', this, function () {

  var context = this

  if ('window' in context) {
    var doc = document
      , byTag = 'getElementsByTagName'
      , head = doc[byTag]('head')[0]
  } else {
    var XHR2
    try {
      XHR2 = require(28)
    } catch (ex) {
      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2')
    }
  }


  var httpsRe = /^http/
    , protocolRe = /(^\w+):\/\//
    , twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    , readyState = 'readyState'
    , contentType = 'Content-Type'
    , requestedWith = 'X-Requested-With'
    , uniqid = 0
    , callbackPrefix = 'reqwest_' + (+new Date())
    , lastValue // data stored by the most recent JSONP callback
    , xmlHttpRequest = 'XMLHttpRequest'
    , xDomainRequest = 'XDomainRequest'
    , noop = function () {}

    , isArray = typeof Array.isArray == 'function'
        ? Array.isArray
        : function (a) {
            return a instanceof Array
          }

    , defaultHeaders = {
          'contentType': 'application/x-www-form-urlencoded'
        , 'requestedWith': xmlHttpRequest
        , 'accept': {
              '*':  'text/javascript, text/html, application/xml, text/xml, */*'
            , 'xml':  'application/xml, text/xml'
            , 'html': 'text/html'
            , 'text': 'text/plain'
            , 'json': 'application/json, text/javascript'
            , 'js':   'application/javascript, text/javascript'
          }
      }

    , xhr = function(o) {
        // is it x-domain
        if (o['crossOrigin'] === true) {
          var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null
          if (xhr && 'withCredentials' in xhr) {
            return xhr
          } else if (context[xDomainRequest]) {
            return new XDomainRequest()
          } else {
            throw new Error('Browser does not support cross-origin requests')
          }
        } else if (context[xmlHttpRequest]) {
          return new XMLHttpRequest()
        } else if (XHR2) {
          return new XHR2()
        } else {
          return new ActiveXObject('Microsoft.XMLHTTP')
        }
      }
    , globalSetupOptions = {
        dataFilter: function (data) {
          return data
        }
      }

  function succeed(r) {
    var protocol = protocolRe.exec(r.url)
    protocol = (protocol && protocol[1]) || context.location.protocol
    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response
  }

  function handleReadyState(r, success, error) {
    return function () {
      // use _aborted to mitigate against IE err c00c023f
      // (can't read props on aborted request objects)
      if (r._aborted) return error(r.request)
      if (r._timedOut) return error(r.request, 'Request is aborted: timeout')
      if (r.request && r.request[readyState] == 4) {
        r.request.onreadystatechange = noop
        if (succeed(r)) success(r.request)
        else
          error(r.request)
      }
    }
  }

  function setHeaders(http, o) {
    var headers = o['headers'] || {}
      , h

    headers['Accept'] = headers['Accept']
      || defaultHeaders['accept'][o['type']]
      || defaultHeaders['accept']['*']

    var isAFormData = typeof FormData !== 'undefined' && (o['data'] instanceof FormData);
    // breaks cross-origin requests with legacy browsers
    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith']
    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType']
    for (h in headers)
      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h])
  }

  function setCredentials(http, o) {
    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
      http.withCredentials = !!o['withCredentials']
    }
  }

  function generalCallback(data) {
    lastValue = data
  }

  function urlappend (url, s) {
    return url + (/\?/.test(url) ? '&' : '?') + s
  }

  function handleJsonp(o, fn, err, url) {
    var reqId = uniqid++
      , cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
      , cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId)
      , cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)')
      , match = url.match(cbreg)
      , script = doc.createElement('script')
      , loaded = 0
      , isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1

    if (match) {
      if (match[3] === '?') {
        url = url.replace(cbreg, '$1=' + cbval) // wildcard callback func name
      } else {
        cbval = match[3] // provided callback func name
      }
    } else {
      url = urlappend(url, cbkey + '=' + cbval) // no callback details, add 'em
    }

    context[cbval] = generalCallback

    script.type = 'text/javascript'
    script.src = url
    script.async = true
    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
      // need this for IE due to out-of-order onreadystatechange(), binding script
      // execution to an event listener gives us control over when the script
      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
      script.htmlFor = script.id = '_reqwest_' + reqId
    }

    script.onload = script.onreadystatechange = function () {
      if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
        return false
      }
      script.onload = script.onreadystatechange = null
      script.onclick && script.onclick()
      // Call the user callback with the last value stored and clean up values and scripts.
      fn(lastValue)
      lastValue = undefined
      head.removeChild(script)
      loaded = 1
    }

    // Add the script to the DOM head
    head.appendChild(script)

    // Enable JSONP timeout
    return {
      abort: function () {
        script.onload = script.onreadystatechange = null
        err({}, 'Request is aborted: timeout', {})
        lastValue = undefined
        head.removeChild(script)
        loaded = 1
      }
    }
  }

  function getRequest(fn, err) {
    var o = this.o
      , method = (o['method'] || 'GET').toUpperCase()
      , url = typeof o === 'string' ? o : o['url']
      // convert non-string objects to query-string form unless o['processData'] is false
      , data = (o['processData'] !== false && o['data'] && typeof o['data'] !== 'string')
        ? reqwest.toQueryString(o['data'])
        : (o['data'] || null)
      , http
      , sendWait = false

    // if we're working on a GET request and we have data then we should append
    // query string to end of URL and not post data
    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
      url = urlappend(url, data)
      data = null
    }

    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url)

    // get the xhr from the factory if passed
    // if the factory returns null, fall-back to ours
    http = (o.xhr && o.xhr(o)) || xhr(o)

    http.open(method, url, o['async'] === false ? false : true)
    setHeaders(http, o)
    setCredentials(http, o)
    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
        http.onload = fn
        http.onerror = err
        // NOTE: see
        // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
        http.onprogress = function() {}
        sendWait = true
    } else {
      http.onreadystatechange = handleReadyState(this, fn, err)
    }
    o['before'] && o['before'](http)
    if (sendWait) {
      setTimeout(function () {
        http.send(data)
      }, 200)
    } else {
      http.send(data)
    }
    return http
  }

  function Reqwest(o, fn) {
    this.o = o
    this.fn = fn

    init.apply(this, arguments)
  }

  function setType(header) {
    // json, javascript, text/plain, text/html, xml
    if (header === null) return undefined; //In case of no content-type.
    if (header.match('json')) return 'json'
    if (header.match('javascript')) return 'js'
    if (header.match('text')) return 'html'
    if (header.match('xml')) return 'xml'
  }

  function init(o, fn) {

    this.url = typeof o == 'string' ? o : o['url']
    this.timeout = null

    // whether request has been fulfilled for purpose
    // of tracking the Promises
    this._fulfilled = false
    // success handlers
    this._successHandler = function(){}
    this._fulfillmentHandlers = []
    // error handlers
    this._errorHandlers = []
    // complete (both success and fail) handlers
    this._completeHandlers = []
    this._erred = false
    this._responseArgs = {}

    var self = this

    fn = fn || function () {}

    if (o['timeout']) {
      this.timeout = setTimeout(function () {
        timedOut()
      }, o['timeout'])
    }

    if (o['success']) {
      this._successHandler = function () {
        o['success'].apply(o, arguments)
      }
    }

    if (o['error']) {
      this._errorHandlers.push(function () {
        o['error'].apply(o, arguments)
      })
    }

    if (o['complete']) {
      this._completeHandlers.push(function () {
        o['complete'].apply(o, arguments)
      })
    }

    function complete (resp) {
      o['timeout'] && clearTimeout(self.timeout)
      self.timeout = null
      while (self._completeHandlers.length > 0) {
        self._completeHandlers.shift()(resp)
      }
    }

    function success (resp) {
      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')) // resp can be undefined in IE
      resp = (type !== 'jsonp') ? self.request : resp
      // use global data filter on response text
      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type)
        , r = filteredResponse
      try {
        resp.responseText = r
      } catch (e) {
        // can't assign this in IE<=8, just ignore
      }
      if (r) {
        switch (type) {
        case 'json':
          try {
            resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')')
          } catch (err) {
            return error(resp, 'Could not parse JSON in response', err)
          }
          break
        case 'js':
          resp = eval(r)
          break
        case 'html':
          resp = r
          break
        case 'xml':
          resp = resp.responseXML
              && resp.responseXML.parseError // IE trololo
              && resp.responseXML.parseError.errorCode
              && resp.responseXML.parseError.reason
            ? null
            : resp.responseXML
          break
        }
      }

      self._responseArgs.resp = resp
      self._fulfilled = true
      fn(resp)
      self._successHandler(resp)
      while (self._fulfillmentHandlers.length > 0) {
        resp = self._fulfillmentHandlers.shift()(resp)
      }

      complete(resp)
    }

    function timedOut() {
      self._timedOut = true
      self.request.abort()
    }

    function error(resp, msg, t) {
      resp = self.request
      self._responseArgs.resp = resp
      self._responseArgs.msg = msg
      self._responseArgs.t = t
      self._erred = true
      while (self._errorHandlers.length > 0) {
        self._errorHandlers.shift()(resp, msg, t)
      }
      complete(resp)
    }

    this.request = getRequest.call(this, success, error)
  }

  Reqwest.prototype = {
    abort: function () {
      this._aborted = true
      this.request.abort()
    }

  , retry: function () {
      init.call(this, this.o, this.fn)
    }

    /**
     * Small deviation from the Promises A CommonJs specification
     * http://wiki.commonjs.org/wiki/Promises/A
     */

    /**
     * `then` will execute upon successful requests
     */
  , then: function (success, fail) {
      success = success || function () {}
      fail = fail || function () {}
      if (this._fulfilled) {
        this._responseArgs.resp = success(this._responseArgs.resp)
      } else if (this._erred) {
        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._fulfillmentHandlers.push(success)
        this._errorHandlers.push(fail)
      }
      return this
    }

    /**
     * `always` will execute whether the request succeeds or fails
     */
  , always: function (fn) {
      if (this._fulfilled || this._erred) {
        fn(this._responseArgs.resp)
      } else {
        this._completeHandlers.push(fn)
      }
      return this
    }

    /**
     * `fail` will execute when the request fails
     */
  , fail: function (fn) {
      if (this._erred) {
        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._errorHandlers.push(fn)
      }
      return this
    }
  , 'catch': function (fn) {
      return this.fail(fn)
    }
  }

  function reqwest(o, fn) {
    return new Reqwest(o, fn)
  }

  // normalize newline variants according to spec -> CRLF
  function normalize(s) {
    return s ? s.replace(/\r?\n/g, '\r\n') : ''
  }

  function serial(el, cb) {
    var n = el.name
      , t = el.tagName.toLowerCase()
      , optCb = function (o) {
          // IE gives value="" even where there is no value attribute
          // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
          if (o && !o['disabled'])
            cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']))
        }
      , ch, ra, val, i

    // don't serialize elements that are disabled or without a name
    if (el.disabled || !n) return

    switch (t) {
    case 'input':
      if (!/reset|button|image|file/i.test(el.type)) {
        ch = /checkbox/i.test(el.type)
        ra = /radio/i.test(el.type)
        val = el.value
        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val))
      }
      break
    case 'textarea':
      cb(n, normalize(el.value))
      break
    case 'select':
      if (el.type.toLowerCase() === 'select-one') {
        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null)
      } else {
        for (i = 0; el.length && i < el.length; i++) {
          el.options[i].selected && optCb(el.options[i])
        }
      }
      break
    }
  }

  // collect up all form elements found from the passed argument elements all
  // the way down to child elements; pass a '<form>' or form fields.
  // called with 'this'=callback to use for serial() on each element
  function eachFormElement() {
    var cb = this
      , e, i
      , serializeSubtags = function (e, tags) {
          var i, j, fa
          for (i = 0; i < tags.length; i++) {
            fa = e[byTag](tags[i])
            for (j = 0; j < fa.length; j++) serial(fa[j], cb)
          }
        }

    for (i = 0; i < arguments.length; i++) {
      e = arguments[i]
      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb)
      serializeSubtags(e, [ 'input', 'select', 'textarea' ])
    }
  }

  // standard query string style serialization
  function serializeQueryString() {
    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments))
  }

  // { 'name': 'value', ... } style serialization
  function serializeHash() {
    var hash = {}
    eachFormElement.apply(function (name, value) {
      if (name in hash) {
        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]])
        hash[name].push(value)
      } else hash[name] = value
    }, arguments)
    return hash
  }

  // [ { name: 'name', value: 'value' }, ... ] style serialization
  reqwest.serializeArray = function () {
    var arr = []
    eachFormElement.apply(function (name, value) {
      arr.push({name: name, value: value})
    }, arguments)
    return arr
  }

  reqwest.serialize = function () {
    if (arguments.length === 0) return ''
    var opt, fn
      , args = Array.prototype.slice.call(arguments, 0)

    opt = args.pop()
    opt && opt.nodeType && args.push(opt) && (opt = null)
    opt && (opt = opt.type)

    if (opt == 'map') fn = serializeHash
    else if (opt == 'array') fn = reqwest.serializeArray
    else fn = serializeQueryString

    return fn.apply(null, args)
  }

  reqwest.toQueryString = function (o, trad) {
    var prefix, i
      , traditional = trad || false
      , s = []
      , enc = encodeURIComponent
      , add = function (key, value) {
          // If value is a function, invoke it and return its value
          value = ('function' === typeof value) ? value() : (value == null ? '' : value)
          s[s.length] = enc(key) + '=' + enc(value)
        }
    // If an array was passed in, assume that it is an array of form elements.
    if (isArray(o)) {
      for (i = 0; o && i < o.length; i++) add(o[i]['name'], o[i]['value'])
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in o) {
        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add)
      }
    }

    // spaces should be + according to spec
    return s.join('&').replace(/%20/g, '+')
  }

  function buildParams(prefix, obj, traditional, add) {
    var name, i, v
      , rbracket = /\[\]$/

    if (isArray(obj)) {
      // Serialize array item.
      for (i = 0; obj && i < obj.length; i++) {
        v = obj[i]
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v)
        } else {
          buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add)
        }
      }
    } else if (obj && obj.toString() === '[object Object]') {
      // Serialize object item.
      for (name in obj) {
        buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
      }

    } else {
      // Serialize scalar item.
      add(prefix, obj)
    }
  }

  reqwest.getcallbackPrefix = function () {
    return callbackPrefix
  }

  // jQuery and Zepto compatibility, differences can be remapped here so you can call
  // .ajax.compat(options, callback)
  reqwest.compat = function (o, fn) {
    if (o) {
      o['type'] && (o['method'] = o['type']) && delete o['type']
      o['dataType'] && (o['type'] = o['dataType'])
      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback']
      o['jsonp'] && (o['jsonpCallback'] = o['jsonp'])
    }
    return new Reqwest(o, fn)
  }

  reqwest.ajaxSetup = function (options) {
    options = options || {}
    for (var k in options) {
      globalSetupOptions[k] = options[k]
    }
  }

  return reqwest
});

});
},{"28":28,"8":8}],155:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*! http://mths.be/startswith v0.2.0 by @mathias */
if (!String.prototype.startsWith) {
	(function() {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var toString = {}.toString;
		var startsWith = function(search) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			if (search && toString.call(search) == '[object RegExp]') {
				throw TypeError();
			}
			var stringLength = string.length;
			var searchString = String(search);
			var searchLength = searchString.length;
			var position = arguments.length > 1 ? arguments[1] : undefined;
			// `ToInteger`
			var pos = position ? Number(position) : 0;
			if (pos != pos) { // better `isNaN`
				pos = 0;
			}
			var start = Math.min(Math.max(pos, 0), stringLength);
			// Avoid the `indexOf` call if no match is possible
			if (searchLength + start > stringLength) {
				return false;
			}
			var index = -1;
			while (++index < searchLength) {
				if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
					return false;
				}
			}
			return true;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'startsWith', {
				'value': startsWith,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.startsWith = startsWith;
		}
	}());
}

});
},{"8":8}],156:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errors = {
  /* signin */
  'signin.generic.error': {
    'signin.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.denied.error': {
    'signin.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.unauthorized': {
    'signin.password': {
      msg: 'Sorry, we don\'t recognise your username or password.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.generic.banned': {
    'signin.password': {
      msg: 'This user has been banned for an unspecified reason.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.banned': {
    'signin.password': {
      msg: 'This user has been banned.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.disapproved': {
    'signin.password': {
      msg: 'This user has been disapproved.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.possible spam activity': {
    'signin.password': {
      msg: 'This user has been identified as possible spammer.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.locked out': {
    'signin.password': {
      msg: 'This user has been locked out.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.identification.any.empty': {
    'signin.userName': {
      msg: 'Please enter your username.',
      state: 'error'
    }
  },
  'signin.password.any.empty': {
    'signin.password': {
      msg: 'Please enter your password.',
      state: 'error'
    }
  },
  /* registration */
  'registration.generic.error': {
    'registration.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'registration.denied.error': {
    'registration.password': {
      msg: 'This user is not allowed to register. Please contact customer support.',
      state: 'error'
    }
  },
  'registration..spam': {
    'registration.password': {
      msg: 'Contact customer support',
      state: 'error'
    }
  },
  'registration.username.any.empty': {
    'registration.username': {
      msg: 'Please choose a username.',
      state: 'error'
    }
  },
  'registration.username.string.min': {
    'registration.username': {
      msg: 'Usernames must be at least three characters long.',
      state: 'error'
    }
  },
  'registration.username.string.max': {
    'registration.username': {
      msg: 'Usernames must be no more than 30 characters long.',
      state: 'error'
    }
  },
  'registration.email.duplicate': {
    'registration.email': {
      msg: 'This email address has already been registered.',
      state: 'error'
    }
  },
  'registration.email.string.email': {
    'registration.email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'registration.email.any.empty': {
    'registration.email': {
      msg: 'Please enter an email address.',
      state: 'error'
    }
  },
  'registration.username.string.regex.base': {
    'registration.username': {
      msg: 'Usernames can only contain letters, numbers and the characters _ or -.',
      state: 'error'
    }
  },
  'registration.username.duplicate': {
    'registration.username': {
      msg: 'This username has already been taken.',
      state: 'error'
    }
  },
  'registration.password.any.empty': {
    'registration.password': {
      msg: 'Please choose a password.',
      state: 'error'
    }
  },
  'registration.password.string.min': {
    'registration.password': {
      msg: 'Your password must be at least six characters long.',
      state: 'error'
    }
  },
  'registration.firstName.any.empty': {
    'registration.firstName': {
      msg: 'Please tell us your first name.',
      state: 'error'
    }
  },
  'registration.lastName.any.empty': {
    'registration.lastName': {
      msg: 'Please tell us your last name.',
      state: 'error'
    }
  },
  /* google */
  'google.generic.error': {
    'generic.googlebutton': {
      msg: 'Google error.',
      state: 'error'
    }
  },
  'google.unauthorized': {
    'generic.googlebutton': {
      msg: 'Sorry, Google couldn\'t authorise this user.',
      state: 'error'
    }
  },
  'google.popup.closed': {
    'generic.googlebutton': {
      msg: 'The Google popup has been closed.',
      state: 'error'
    }
  },
  'google.popup.blocked': {
    'generic.googlebutton': {
      msg: 'The Google popup may have been blocked by your browser. Please check your settings.',
      state: 'error'
    }
  },
  'google.usererror': {
    'generic.googlebutton': {
      msg: 'Sorry, Google couldn\'t register or log in this user.',
      state: 'error'
    }
  },
  /* forgot-password */
  'forgot-password.generic.error': {
    'forgot-password.identification': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'forgot-password.denied.error': {
    'forgot-password.identification': {
      msg: 'This user is not allowed to reset the password. Please contact customer support.',
      state: 'error'
    }
  },
  'forgot-password.email.string.email': {
    'forgot-password.identification': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'forgot-password.email.any.empty': {
    'forgot-password.identification': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'forgot-password.user.not-found': {
    'forgot-password.identification': {
      msg: 'Sorry, we don\'t recognise that email address.',
      state: 'error'
    }
  },
  'forgot-password.generic.banned': {
    'forgot-password.identification': {
      msg: 'This user has been banned for an unspecified reason.',
      state: 'error'
    }
  },
  'forgot-password.banned': {
    'forgot-password.identification': {
      msg: 'This user has been banned.',
      state: 'error'
    }
  },
  'forgot-password.disapproved': {
    'forgot-password.identification': {
      msg: 'This user has been disapproved.',
      state: 'error'
    }
  },
  'forgot-password.possible spam activity': {
    'forgot-password.identification': {
      msg: 'This user has been identified as possible spammer.',
      state: 'error'
    }
  },
  'forgot-password.locked out': {
    'forgot-password.identification': {
      msg: 'This user has been locked out.',
      state: 'error'
    }
  },
  /* resend-confirmation-email */
  'resend-confirmation-email.generic.error': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'resend-confirmation-email.email.any.empty': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Please enter an email address.',
      state: 'error'
    }
  },
  'resend-confirmation-email.email.string.email': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'resend-confirmation-email.generic-success': {
    submitted: true,
    success: true
  },
  'reset-password.invalid-token': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, that reset link didn\'t work. Please try a new one.',
      state: 'error'
    }
  },
  /* reset-password */
  'reset-password.generic.error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, we weren\'t able to change your password. Please try again later.',
      state: 'error'
    }
  },
  'reset-password.server-error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, we weren\'t able to change your password. Please try again later.',
      state: 'error'
    }
  },
  'reset-password.token-error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, this link is not valid any more. Can you ask for a new one?',
      state: 'error'
    }
  },
  'reset-password.unable': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, We are unable to change the password, have you already changed it?',
      state: 'error'
    }
  },
  'reset-password.blocked': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, This user is blocked/banned. Contact customer support.',
      state: 'error'
    }
  },
  'reset-password.generic-success': {
    submitted: true,
    success: true
  },
  'edit-account.generic.error': {
    'edit-account.userType': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    },
    'edit-account.message': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    }
  },
  'edit-account.userType.any.allowOnly': {
    'edit-account.userType': {
      msg: 'The user type is not correct, please pick one',
      state: 'error'
    }
  },
  'edit-account.firstName.any.empty': {
    'edit-account.firstName': {
      msg: 'Please tell us your first name.',
      state: 'error'
    }
  },
  'edit-account.lastName.any.empty': {
    'edit-account.lastName': {
      msg: 'Please tell us your last name.',
      state: 'error'
    }
  },
  'edit-account.email.duplicate': {
    'edit-account.email': {
      msg: 'This email address has already been registered.',
      state: 'error'
    }
  },
  'edit-account.email.string.email': {
    'edit-account.email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'edit-account.email.any.empty': {
    'edit-account.email': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'change-password.generic.error': {
    'change-password.password': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    }
  },
  'change-password.password.string.min': {
    'change-password.password': {
      msg: 'Your password must be at least six characters long.',
      state: 'error'
    }
  },
  'change-password.oldpassword.wrong': {
    'change-password.oldPassword': {
      msg: 'Your password is not correct, please try entering it again.',
      state: 'error'
    }
  },
  'change-password.samepassword': {
    'change-password.password': {
      msg: 'The new password is the same as the previous password.',
      state: 'error'
    }
  },
  'change-password.ok': {
    'change-password.message': {
      msg: 'You have succesfully changed your password.',
      state: 'success'
    }
  }
};

exports.default = function (codes) {
  if (!codes) return {};
  var errorCodes = codes.split(',');
  var validErrorCodes = errorCodes.filter(function (code) {
    return code in errors;
  });

  if (validErrorCodes.length === 0) {
    var prefix = errorCodes[0].split('.', 1);
    validErrorCodes.push(prefix + '.generic.error');
  }

  return validErrorCodes.map(function (code) {
    return errors[code];
  }).reduce(function (previous, current) {
    return (0, _assign2.default)({}, previous, current);
  }, {});
};

});
},{"12":12,"8":8}],157:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(24);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(23);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _Signin = require(164);

var _Signin2 = _interopRequireDefault(_Signin);

var _ForgotPassword = require(158);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _SelectPosition = require(163);

var _SelectPosition2 = _interopRequireDefault(_SelectPosition);

var _LoggedInUpdate = require(160);

var _LoggedInUpdate2 = _interopRequireDefault(_LoggedInUpdate);

var _LoggedInSelectPosition = require(159);

var _LoggedInSelectPosition2 = _interopRequireDefault(_LoggedInSelectPosition);

var _Register = require(161);

var _Register2 = _interopRequireDefault(_Register);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(176);

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TesModalContainer(_ref) {
  var hasWrapper = _ref.hasWrapper,
      noWrapperStyle = _ref.noWrapperStyle,
      children = _ref.children;

  if (!hasWrapper) return _react2.default.createElement(
    'div',
    { style: noWrapperStyle },
    children
  );
  return _react2.default.createElement(
    'div',
    { className: 'tes-modal__body' },
    children
  );
}

TesModalContainer.propTypes = {
  hasWrapper: _react.PropTypes.bool,
  noWrapperStyle: _react.PropTypes.object
};

var App = exports.App = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.trackDisplay(this.props.common.formType);
      if (!this.props.common.isModal && !this.props.common.isInline) {
        this.props.actions.failRegister(this.props.errors);
        this.props.actions.failSignIn(this.props.errors);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isModal = this.props.common.isModal;

      var borderStyle = {};
      var components = {
        'sign-in': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_Signin2.default, null)
        ),
        register: _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_Register2.default, null)
        ),
        'forgot-password': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_ForgotPassword2.default, null)
        ),
        select: _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: false, noWrapperStyle: isModal ? {} : borderStyle },
          _react2.default.createElement(_SelectPosition2.default, { onClick: function onClick() {}, action: '', method: '' })
        ),
        'logged-in-select': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: false },
          _react2.default.createElement(_LoggedInSelectPosition2.default, null)
        ),
        'logged-in-update': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_LoggedInUpdate2.default, null)
        )
      };
      var component = components[this.props.common.formType];
      return component;
    }
  }]);
  return App;
}(_react.Component);

App.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired,
  forgotPassword: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn,
    register: state.register,
    forgotPassword: state.forgotPassword
  };
}, mapDispatchToProps)(App);

});
},{"15":15,"158":158,"159":159,"160":160,"161":161,"163":163,"164":164,"176":176,"21":21,"22":22,"23":23,"24":24,"8":8}],158:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForgotPassword = undefined;

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(24);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(23);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(172);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(176);

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require(169);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require(167);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('forgot-password');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('forgot-password');

var ForgotPassword = exports.ForgotPassword = function (_Component) {
  (0, _inherits3.default)(ForgotPassword, _Component);

  function ForgotPassword() {
    (0, _classCallCheck3.default)(this, ForgotPassword);
    return (0, _possibleConstructorReturn3.default)(this, (ForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(ForgotPassword)).apply(this, arguments));
  }

  (0, _createClass3.default)(ForgotPassword, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      this.props.actions.initForgotPassword();
    }
  }, {
    key: 'handleContinue',
    value: function handleContinue(e) {
      e.preventDefault();
      this.props.actions.successForgotPassword();
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('forgot-password.');
      }).length > 0 : false;
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'forgot-password.' + namepar;
      var deps = depspar.map(function (n) {
        return 'forgotpassword.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('forgotPassword', target.name, target.value);
        _this2.props.actions.changeField(name, deps);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;

      var content = void 0;
      if (this.props.forgotPassword.state === 'sent') {
        content = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Email sent! Please now check your inbox'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'These emails can get caught in spam - please also check your spam folder.'
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick(e) {
                return _this3.handleContinue(e);
              }, className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary' },
            'Continue',
            _react2.default.createElement('span', { 'aria-hidden': 'true' })
          )
        );
      } else {
        content = _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return _this3.handleSubmit(e);
            }, role: 'form', method: 'post', className: 't-forgot-password-form' },
          _react2.default.createElement(_HiddenInputs2.default, null),
          _react2.default.createElement(
            'div',
            { className: getErrorCls('identification')(err) },
            _react2.default.createElement(
              'div',
              { className: 'tes-input-group' },
              _react2.default.createElement(
                'span',
                { className: 'tes-input-group__addon' },
                _react2.default.createElement('i', { className: 'icon icon-user' })
              ),
              _react2.default.createElement('input', { type: 'text', onChange: this.changeField('identification', []),
                name: 'identification',
                autoFocus: 'true',
                placeholder: 'email',
                value: this.props.forgotPassword.identification,
                className: 'tes-control tes-control--group identification-field t-identification'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'tes-help-block' },
              getErrorMsg('identification')(err)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-top-md margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { disabled: this.props.forgotPassword.state === 'wait' ? 'disabled' : null, type: 'submit', className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary forgot-password-submit' },
              this.props.forgotPassword.state === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white' }) : 'Send'
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            'Recover your password'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Send us your email and we will send you instructions to reset your password.'
          )
        ),
        content,
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-sm border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Remember your password?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return ForgotPassword;
}(_react.Component);

ForgotPassword.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired,
  forgotPassword: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn,
    register: state.register,
    forgotPassword: state.forgotPassword
  };
}, mapDispatchToProps)(ForgotPassword);

});
},{"15":15,"16":16,"167":167,"169":169,"172":172,"176":176,"21":21,"22":22,"23":23,"24":24,"8":8}],159:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoggedInSelectPosition;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectFormPosition = require(162);

var _SelectFormPosition2 = _interopRequireDefault(_SelectFormPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoggedInSelectPosition() {
  return _react2.default.createElement(_SelectFormPosition2.default, {
    isStandAlone: true,
    action: '/api/authn/edit-account',
    method: 'post'
  });
}

});
},{"162":162,"8":8}],160:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggedInUpdate = undefined;

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(24);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(23);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(172);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(176);

var actionCreators = _interopRequireWildcard(_actions);

var _InputField = require(168);

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('edit-account');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('edit-account');

var LoggedInUpdate = exports.LoggedInUpdate = function (_Component) {
  (0, _inherits3.default)(LoggedInUpdate, _Component);

  function LoggedInUpdate(props) {
    (0, _classCallCheck3.default)(this, LoggedInUpdate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoggedInUpdate.__proto__ || (0, _getPrototypeOf2.default)(LoggedInUpdate)).call(this, props));

    _this.state = {
      firstName: '',
      lastName: '',
      email: '',
      userType: _this.props.common.userType
    };
    return _this;
  }

  (0, _createClass3.default)(LoggedInUpdate, [{
    key: 'onChange',
    value: function onChange(e, name) {
      var data = {};
      data[name] = e.target.value;
      this.setState(data);
    }
  }, {
    key: 'getActiveFields',
    value: function getActiveFields() {
      var variants = {
        fullname: {
          title: 'Please add your full name',
          helpLink: 'Why are you being asked for your name?',
          helpText: 'This section of our site requires your name as you will be interacting with schools, institutions or other members of TES in a professional context. Using your actual name here improves the service and will allow you to interact with others with greater transparency and trust.',
          validFields: ['firstName', 'lastName']
        },
        email: {
          title: 'Please add your email',
          validFields: ['email', 'userType']
        }
      };

      if (!variants[this.props.common.variant]) {
        return variants.fullname;
      }
      return variants[this.props.common.variant];
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();

      var activeFields = this.getActiveFields();
      var hasField = function hasField(name) {
        return activeFields.validFields.indexOf(name) !== -1;
      };

      var data = {};
      if (hasField('firstName')) {
        data.firstName = this.state.firstName;
      }
      if (hasField('lastName')) {
        data.lastName = this.state.lastName;
      }
      if (hasField('email')) {
        data.email = this.state.email;
      }
      if (hasField('userType')) {
        data.userType = this.state.userType;
      }
      this.props.actions.resetErrors();
      this.props.actions.updateUserData(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var err = this.props.errors;
      var activeFields = this.getActiveFields();
      var hasField = function hasField(name) {
        return activeFields.validFields.indexOf(name) !== -1;
      };

      return _react2.default.createElement(
        'div',
        { id: 'logged-in-update', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            activeFields.title
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', role: 'form', onSubmit: function onSubmit(e) {
                return _this2.handleSubmit(e);
              }, className: 't-logged-in-update margin-bottom-md', method: 'post', action: '/api/authn/edit-account' },
            this.props.common.rtn ? _react2.default.createElement('input', { type: 'hidden', name: 'rtn', value: encodeURIComponent(this.props.common.rtn) }) : null,
            hasField('userType') && this.props.common.userType ? _react2.default.createElement('input', { className: 't-user-type', type: 'hidden', name: 'userType', ref: 'userType', value: this.props.common.userType }) : null,
            _react2.default.createElement('input', { type: 'hidden', name: 'appId', value: this.props.common.appId }),
            _react2.default.createElement('input', { type: 'hidden', name: '_CSRF_TOKEN', value: this.props.common.csrfToken }),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                hasField('firstName') ? _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'First name', value: this.state.firstName,
                  errorClass: getErrorCls('firstName')(err),
                  errorMessage: getErrorMsg('firstName')(err),
                  onChange: function onChange(e) {
                    return _this2.onChange(e, 'firstName');
                  },
                  autoFocus: 'true'
                }) : null
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                hasField('lastName') ? _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'Last name', value: this.state.lastName,
                  errorClass: getErrorCls('lastName')(err),
                  errorMessage: getErrorMsg('lastName')(err),
                  onChange: function onChange(e) {
                    return _this2.onChange(e, 'lastName');
                  }
                }) : null
              )
            ),
            hasField('email') ? _react2.default.createElement(_InputField2.default, {
              name: 'email',
              label: this.props.common.userType === 'student' ? 'Email (optional)' : 'Email',
              value: this.state.email,
              errorClass: getErrorCls('email')(err),
              errorMessage: getErrorMsg('email')(err),
              onChange: function onChange(e) {
                return _this2.onChange(e, 'email');
              }
            }) : null,
            activeFields.helpLink ? _react2.default.createElement(
              'div',
              { className: 'margin-bottom-xs' },
              _react2.default.createElement(
                'span',
                { className: 'link link--colored text--xs', title: activeFields.helpText },
                activeFields.helpLink
              )
            ) : null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { type: 'submit', className: 'tes-btn tes-btn--icon tes-btn--lg tes-btn--block tes-btn--primary' },
                'Confirm'
              )
            )
          )
        )
      );
    }
  }]);
  return LoggedInUpdate;
}(_react.Component);

LoggedInUpdate.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors
  };
}, mapDispatchToProps)(LoggedInUpdate);

});
},{"15":15,"168":168,"172":172,"176":176,"21":21,"22":22,"23":23,"24":24,"8":8}],161:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Register = undefined;

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(24);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(23);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(172);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(176);

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require(169);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require(167);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _InputField = require(168);

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('registration');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('registration');
var getGenericErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('generic');
var getGenericErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('generic');

var Register = exports.Register = function (_Component) {
  (0, _inherits3.default)(Register, _Component);

  function Register() {
    (0, _classCallCheck3.default)(this, Register);
    return (0, _possibleConstructorReturn3.default)(this, (Register.__proto__ || (0, _getPrototypeOf2.default)(Register)).apply(this, arguments));
  }

  (0, _createClass3.default)(Register, [{
    key: 'getGoogleLogoURL',
    value: function getGoogleLogoURL() {
      return this.props.common.cdnUrl + 'img/google-logo-g.png';
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'registration.' + namepar;
      var deps = depspar.map(function (n) {
        return 'registration.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('register', target.name, target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value);
        _this2.props.actions.changeField(name, deps);
        _this2.props.actions.validateField(name);
      };
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('registration.');
      }).length > 0 : false;
    }
  }, {
    key: 'handleGoogle',
    value: function handleGoogle() {
      this.props.actions.initGoogleSignIn();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var target = e.target;
      this.props.actions.initRegister(function () {
        target.submit(); // only called for pages
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;
      var hasName = !this.props.common.omitName;

      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            'Join TES for free'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.register.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  onClick: function onClick(e) {
                    return _this3.handleGoogle(e);
                  },
                  className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block tes-btn--social'
                },
                this.props.common.googleState === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                  'span',
                  { className: 'text--sm' },
                  _react2.default.createElement('img', { style: { padding: '0 6px 2px 0', verticalAlign: 'middle' }, src: this.getGoogleLogoURL() }),
                  ' Register with Google'
                )
              )
            )
          ),
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', role: 'form', onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              }, className: 't-register-form margin-bottom-md', method: 'post', action: '/api/authn/register-redirect' },
            _react2.default.createElement(_HiddenInputs2.default, null),
            _react2.default.createElement(
              'div',
              { className: 'separator' },
              _react2.default.createElement(
                'span',
                { className: 'separator--text bg-white' },
                'or'
              )
            ),
            hasName ? _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'First name', value: this.props.register.firstName,
                  errorClass: getErrorCls('firstName')(err),
                  errorMessage: getErrorMsg('firstName')(err),
                  onChange: this.changeField('firstName', [])
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                _react2.default.createElement(_InputField2.default, {
                  name: 'lastName', label: 'Last name', value: this.props.register.lastName,
                  errorClass: getErrorCls('lastName')(err),
                  errorMessage: getErrorMsg('lastName')(err),
                  onChange: this.changeField('lastName', [])
                })
              )
            ) : null,
            _react2.default.createElement(_InputField2.default, {
              name: 'email',
              label: this.props.common.userType === 'student' ? 'Email (optional)' : 'Email',
              value: this.props.register.email,
              errorClass: getErrorCls('email')(err),
              errorMessage: getErrorMsg('email')(err),
              onChange: this.changeField('email', []),
              type: 'email'
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'username',
              label: 'Username',
              value: this.props.register.username,
              errorClass: getErrorCls('username')(err),
              errorMessage: getErrorMsg('username')(err),
              onChange: this.changeField('username', [])
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'password',
              label: 'password',
              value: this.props.register.password,
              errorClass: getErrorCls('password')(err),
              errorMessage: getErrorMsg('password')(err),
              onChange: this.changeField('password', []),
              type: 'password'
            }),
            this.props.common.userType !== 'student' ? _react2.default.createElement(
              'div',
              { className: 'tes-checkbox tes-checkbox--inline text--sm margin-bottom-sm' },
              _react2.default.createElement(
                'label',
                { className: 'tes-control-label text--xs' },
                _react2.default.createElement('input', { onChange: this.changeField('newsletter', []),
                  type: 'checkbox', name: 'newsletter',
                  className: 't-newsletter',
                  value: 'true',
                  checked: this.props.register.newsletter
                }),
                _react2.default.createElement(
                  'span',
                  { className: 'text--xs' },
                  ' Uncheck this box if you do not want to receive news and updates from TES'
                )
              )
            ) : null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { disabled: this.props.register.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  type: 'submit', className: 'tes-btn tes-btn--icon tes-btn--lg sign-up-submit tes-btn--block tes-btn--primary'
                },
                this.props.register.state === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white tes-btn__icon' }) : 'Register'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'text--secondary col-xs-12', style: { paddingRight: 0 } },
              _react2.default.createElement(
                'div',
                { className: 'margin-bottom-md' },
                'By registering, you are agreeing to our ',
                _react2.default.createElement(
                  'a',
                  { target: '_blank', className: 'link link--colored', href: 'https://www.tes.com/content/terms-and-conditions' },
                  'terms and conditions'
                ),
                ' and ',
                _react2.default.createElement(
                  'a',
                  { target: '_blank', className: 'link link--colored', href: 'https://www.tes.com/us/privacy-policy' },
                  'privacy policy'
                )
              )
            )
          ),
          getGenericErrorCls('googlebutton')(err) ? _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'tes-has-error col-xs-12' },
              _react2.default.createElement(
                'div',
                { className: 'tes-help-block' },
                getGenericErrorMsg('googlebutton')(err)
              )
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-md border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Already have a TES account?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return Register;
}(_react.Component);

Register.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    register: state.register
  };
}, mapDispatchToProps)(Register);

});
},{"15":15,"16":16,"167":167,"168":168,"169":169,"172":172,"176":176,"21":21,"22":22,"23":23,"24":24,"8":8}],162:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectFormPosition = undefined;

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(24);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(23);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(176);

var actionCreators = _interopRequireWildcard(_actions);

var _HiddenInputs = require(167);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _WidgetLink = require(169);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _CustomSelect = require(166);

var _CustomSelect2 = _interopRequireDefault(_CustomSelect);

var _ButtonSelect = require(165);

var _ButtonSelect2 = _interopRequireDefault(_ButtonSelect);

var _positionFilter = require(173);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectFormPosition = exports.SelectFormPosition = function (_Component) {
  (0, _inherits3.default)(SelectFormPosition, _Component);

  function SelectFormPosition(props) {
    (0, _classCallCheck3.default)(this, SelectFormPosition);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectFormPosition.__proto__ || (0, _getPrototypeOf2.default)(SelectFormPosition)).call(this, props));

    var positions = props.refdata.positions;
    var careers = props.refdata.careers;
    var currentPosition = props.common.position;
    var currentCareerObj = (0, _positionFilter.careerFinder)(positions, careers, currentPosition);

    _this.state = { currentCareerObj: currentCareerObj };
    return _this;
  }

  (0, _createClass3.default)(SelectFormPosition, [{
    key: 'onChangeCareer',
    value: function onChangeCareer(currentCareer) {
      var _this2 = this;

      var filteredCareers = this.props.refdata.careers.filter(function (item) {
        return currentCareer === item.name;
      });
      var currentCareerObj = filteredCareers.length ? filteredCareers[0] : { name: '', groupLabel: null };

      this.setState({ currentCareerObj: currentCareerObj });

      var positions = this.props.refdata.positions;
      var validPosition = (0, _positionFilter.filterPosition)(positions, currentCareerObj);

      var newPosition = validPosition.length === 1 ? validPosition[0].name : '';
      var newUserType = validPosition.length === 1 ? validPosition[0].userType : 'other';
      this.props.actions.setPosition(newPosition, newUserType);
      if (!currentCareerObj.groupLabel) {
        setTimeout(function () {
          return _this2.refs.submit.click();
        }, 50); // wait to render the interface with the correct field
      }
    }
  }, {
    key: 'onChangePosition',
    value: function onChangePosition(newPosition) {
      var _this3 = this;

      var positions = this.props.refdata.positions;
      var filteredPositions = positions.filter(function (p) {
        return newPosition === p.name;
      });

      var newUserType = filteredPositions.length ? filteredPositions[0].userType : 'other';
      this.props.actions.setPosition(newPosition, newUserType);
      setTimeout(function () {
        return _this3.refs.submit.click();
      }, 50); // wait to render the interface with the correct field
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(e) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();
      var position = this.props.common.position;
      var userType = (0, _positionFilter.getUserTypePosition)(this.props.refdata.positions, position);

      this.props.actions.setUserType(userType);

      if (this.props.isStandAlone) {
        this.props.actions.updateUserData({ userType: userType, position: position });
      } else {
        this.props.actions.initSetFormType('register');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props$refdata = this.props.refdata,
          positions = _props$refdata.positions,
          careers = _props$refdata.careers;

      var currentPosition = this.props.common.position;
      var currentCareerObj = this.state.currentCareerObj;

      var positionOptions = (0, _positionFilter.filterPosition)(positions, currentCareerObj).map(function (pos) {
        return {
          label: pos.name,
          value: pos.name
        };
      });

      var careerOptions = careers.map(function (pos) {
        return {
          label: pos.name,
          value: pos.name
        };
      });

      return _react2.default.createElement(
        'div',
        { id: 'select-position' },
        _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_top' },
          _react2.default.createElement(
            'div',
            { className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
            _react2.default.createElement(
              'div',
              { className: 'heading-main text-center' },
              _react2.default.createElement(
                'h3',
                { className: 'tes-modal__heading margin-bottom-sm' },
                'Join TES for free'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_middle' },
          _react2.default.createElement(
            'div',
            { className: 'padding-md' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h4',
                { className: 'tes-modal__heading text--white text-white margin-bottom-sm' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I am a ...'
                )
              )
            ),
            _react2.default.createElement(
              'form',
              { autoComplete: 'off', className: 't-student-form app-authentication-select-form',
                action: this.props.action, method: this.props.method,
                onSubmit: this.props.onSubmit
              },
              _react2.default.createElement(_HiddenInputs2.default, { isGetRequest: this.props.method.toLowerCase() === 'get', noPosition: true }),
              _react2.default.createElement(
                'div',
                { className: 'padding-bottom-md' },
                _react2.default.createElement(_ButtonSelect2.default, {
                  id: 'career-selector',
                  onChange: function onChange(v) {
                    return _this4.onChangeCareer(v);
                  },
                  value: currentCareerObj.name,
                  options: careerOptions,
                  emptyOptionLabel: 'Choose your role'
                })
              ),
              currentCareerObj.groupLabel ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'padding-bottom-md' },
                  _react2.default.createElement(_CustomSelect2.default, {
                    id: 'position-selector',
                    className: 'tes-control tes-select',
                    name: 'position',
                    onChange: function onChange(v) {
                      return _this4.onChangePosition(v);
                    },
                    value: currentPosition,
                    options: positionOptions,
                    emptyOptionLabel: 'Choose a position'
                  })
                )
              ) : _react2.default.createElement('input', { type: 'hidden', name: 'position', value: currentPosition }),
              _react2.default.createElement(
                'button',
                { ref: 'submit', onClick: function onClick(e) {
                    return _this4.onSubmit(e);
                  }, type: 'submit', className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary hidden' },
                'Ok'
              )
            )
          )
        ),
        !this.props.isStandAlone ? _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_bottom' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-md border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Already have a TES account?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        ) : null
      );
    }
  }]);
  return SelectFormPosition;
}(_react.Component);

SelectFormPosition.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  refdata: _react.PropTypes.object.isRequired,
  isStandAlone: _react.PropTypes.bool,
  action: _react.PropTypes.string.isRequired,
  method: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    refdata: state.refdata
  };
}, mapDispatchToProps)(SelectFormPosition);

});
},{"15":15,"165":165,"166":166,"167":167,"169":169,"173":173,"176":176,"21":21,"22":22,"23":23,"24":24,"8":8}],163:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectPosition;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectFormPosition = require(162);

var _SelectFormPosition2 = _interopRequireDefault(_SelectFormPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectPosition() {
  return _react2.default.createElement(_SelectFormPosition2.default, {
    action: '/authn/register',
    method: 'get'
  });
}

});
},{"162":162,"8":8}],164:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Signin = undefined;

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(24);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(23);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(172);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(176);

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require(169);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require(167);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _InputField = require(168);

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('signin');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('signin');
var getGenericErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('generic');
var getGenericErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('generic');

var Signin = exports.Signin = function (_Component) {
  (0, _inherits3.default)(Signin, _Component);

  function Signin() {
    (0, _classCallCheck3.default)(this, Signin);
    return (0, _possibleConstructorReturn3.default)(this, (Signin.__proto__ || (0, _getPrototypeOf2.default)(Signin)).apply(this, arguments));
  }

  (0, _createClass3.default)(Signin, [{
    key: 'getGoogleLogoURL',
    value: function getGoogleLogoURL() {
      return this.props.common.cdnUrl + 'img/google-logo-g.png';
    }
  }, {
    key: 'handleGoogle',
    value: function handleGoogle() {
      this.props.actions.initGoogleSignIn();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var target = e.target;

      this.props.actions.initSignIn(function () {
        target.submit();
      });
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('signin.');
      }).length > 0 : false;
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'signin.' + namepar;
      var deps = depspar.map(function (n) {
        return 'signin.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('signIn', target.name, target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value);
        _this2.props.actions.changeField(name, deps);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;

      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            'Please log in'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  onClick: function onClick(e) {
                    return _this3.handleGoogle(e);
                  },
                  className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block tes-btn--social'
                },
                this.props.common.googleState === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                  'span',
                  { className: 'text--sm' },
                  _react2.default.createElement('img', { style: { padding: '0 6px 2px 0', verticalAlign: 'middle' }, src: this.getGoogleLogoURL() }),
                  ' Log in with Google'
                )
              )
            )
          ),
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              }, role: 'form', className: 't-sign-in-form margin-bottom-sm', method: 'post', action: '/api/authn/sign-in-redirect' },
            _react2.default.createElement(_HiddenInputs2.default, null),
            _react2.default.createElement(
              'div',
              { className: 'separator' },
              _react2.default.createElement(
                'span',
                { className: 'separator--text bg-white' },
                'or'
              )
            ),
            _react2.default.createElement(_InputField2.default, {
              name: 'identification',
              label: 'Username or email',
              icon: 'user',
              value: this.props.signIn.identification,
              errorClass: getErrorCls('userName')(err),
              errorMessage: getErrorMsg('userName')(err),
              onChange: this.changeField('userName', ['password']),
              autoFocus: 'true',
              autoComplete: 'off'
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'password',
              label: 'Password',
              icon: 'lock',
              value: this.props.signIn.password,
              errorClass: getErrorCls('password')(err),
              errorMessage: getErrorMsg('password')(err),
              onChange: this.changeField('password', ['userName']),
              type: 'password',
              autoComplete: 'off'
            }),
            _react2.default.createElement(
              'div',
              { className: 'text--sm margin-bottom-md margin-top-md' },
              _react2.default.createElement(
                'div',
                { className: 'tes-checkbox tes-checkbox--inline' },
                _react2.default.createElement(
                  'label',
                  { className: 'tes-control-label', title: 'This shouldn\'t be used on a shared computer' },
                  _react2.default.createElement('input', { type: 'checkbox',
                    name: 'trustedComputer',
                    value: 'true',
                    checked: this.props.signIn.trustedComputer,
                    onChange: this.changeField('trustedComputer', [])
                  }),
                  _react2.default.createElement(
                    'span',
                    { className: 'text--sm' },
                    'Stay logged in'
                  )
                )
              ),
              _react2.default.createElement(
                _WidgetLink2.default,
                { formType: 'forgotPassword' },
                'Forgot password?'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  type: 'submit', className: 'tes-btn tes-btn--lg sign-in-submit tes-btn--icon tes-btn--block tes-btn--primary'
                },
                this.props.signInstate === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white tes-btn__icon' }) : 'Log in'
              )
            )
          ),
          getGenericErrorCls('googlebutton')(err) ? _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 tes-has-error' },
              _react2.default.createElement(
                'div',
                { className: 'tes-help-block' },
                getGenericErrorMsg('googlebutton')(err)
              )
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-sm' },
            _react2.default.createElement(
              'span',
              null,
              'Not a member yet?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'register' },
              'Join us for free'
            )
          )
        )
      );
    }
  }]);
  return Signin;
}(_react.Component);

Signin.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn
  };
}, mapDispatchToProps)(Signin);

});
},{"15":15,"16":16,"167":167,"168":168,"169":169,"172":172,"176":176,"21":21,"22":22,"23":23,"24":24,"8":8}],165:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(24);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(23);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonSelect = function (_Component) {
  (0, _inherits3.default)(ButtonSelect, _Component);

  function ButtonSelect(props) {
    (0, _classCallCheck3.default)(this, ButtonSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ButtonSelect.__proto__ || (0, _getPrototypeOf2.default)(ButtonSelect)).call(this, props));

    _this.state = { value: props.value || '' };
    return _this;
  }

  (0, _createClass3.default)(ButtonSelect, [{
    key: 'onClick',
    value: function onClick(e, value) {
      e.preventDefault();
      var newValue = value;
      if (newValue !== this.state.value) {
        this.setState({ value: newValue });
        this.props.onChange(newValue);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = this.props.options;

      return _react2.default.createElement(
        'div',
        {
          id: this.props.id,
          className: this.props.className
        },
        this.props.name ? _react2.default.createElement('input', { type: 'hidden', value: this.state.value, name: this.props.name }) : null,
        options.map(function (p, index) {
          return p.value === _this2.state.value ? _react2.default.createElement(
            'div',
            { key: 'select-button-' + index, className: 'margin-top-sm margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { className: 'tes-btn tes-btn--secondary-gray-text tes-btn--block', disabled: true },
              p.label
            )
          ) : _react2.default.createElement(
            'div',
            { key: 'select-button-' + index, className: 'margin-top-sm margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { className: 'tes-btn tes-btn--primary tes-btn--block', onClick: function onClick(e) {
                  return _this2.onClick(e, p.value);
                } },
              p.label
            )
          );
        })
      );
    }
  }]);
  return ButtonSelect;
}(_react.Component);

exports.default = ButtonSelect;


ButtonSelect.propTypes = {
  id: _react.PropTypes.string,
  className: _react.PropTypes.string,
  options: _react.PropTypes.array.isRequired,
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.string,
  name: _react.PropTypes.string
};

});
},{"15":15,"21":21,"22":22,"23":23,"24":24,"8":8}],166:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(24);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(23);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomSelect = function (_Component) {
  (0, _inherits3.default)(CustomSelect, _Component);

  function CustomSelect(props) {
    (0, _classCallCheck3.default)(this, CustomSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomSelect.__proto__ || (0, _getPrototypeOf2.default)(CustomSelect)).call(this, props));

    _this.state = { value: props.value || '' };
    return _this;
  }

  (0, _createClass3.default)(CustomSelect, [{
    key: 'onChange',
    value: function onChange(e) {
      var newValue = e.target.value;
      if (newValue !== this.state.value) {
        this.setState({ value: newValue });
        this.props.onChange(newValue);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = [];
      if (this.props.emptyOptionLabel) {
        options.push({
          label: this.props.emptyOptionLabel,
          value: ''
        });
      }
      options = options.concat(this.props.options);

      return _react2.default.createElement(
        'select',
        {
          autoComplete: 'off',
          id: this.props.id,
          className: this.props.className,
          onChange: function onChange(e) {
            return _this2.onChange(e);
          },
          value: this.state.value,
          name: this.props.name
        },
        options.map(function (p, index) {
          return _react2.default.createElement(
            'option',
            { key: 'select-' + index, value: p.value },
            p.label
          );
        })
      );
    }
  }]);
  return CustomSelect;
}(_react.Component);

exports.default = CustomSelect;


CustomSelect.propTypes = {
  id: _react.PropTypes.string,
  className: _react.PropTypes.string,
  options: _react.PropTypes.array.isRequired,
  emptyOptionLabel: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.string,
  name: _react.PropTypes.string
};

});
},{"15":15,"21":21,"22":22,"23":23,"24":24,"8":8}],167:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenInputs = HiddenInputs;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _tracking = require(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HiddenInputs(_ref) {
  var common = _ref.common,
      isGetRequest = _ref.isGetRequest,
      noUserType = _ref.noUserType,
      noPosition = _ref.noPosition;

  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var pageContextInputs = ['pageId', 'pageType', 'pageSection', 'pageSubSection'].filter(function (name) {
    return pageContext && pageContext[name];
  }).map(function (name) {
    return _react2.default.createElement('input', { type: 'hidden', key: name, name: name, value: pageContext[name] });
  });

  return _react2.default.createElement(
    'span',
    null,
    pageContextInputs,
    common.rtn ? _react2.default.createElement('input', { type: 'hidden', name: 'rtn', value: common.rtn }) : null,
    !noUserType ? _react2.default.createElement('input', { className: 't-user-type', type: 'hidden', name: 'userType', value: common.userType || 'other' }) : null,
    !noPosition && common.position ? _react2.default.createElement('input', { className: 't-position', type: 'hidden', name: 'position', value: common.position }) : null,
    common.regUrl ? _react2.default.createElement('input', { className: 't-reg-url', type: 'hidden', name: 'regUrl', value: common.regUrl }) : null,
    _react2.default.createElement('input', { type: 'hidden', name: 'appId', value: common.appId }),
    !isGetRequest ? _react2.default.createElement('input', { type: 'hidden', name: '_CSRF_TOKEN', value: common.csrfToken }) : null,
    common.doSelectUserType ? _react2.default.createElement('input', { className: 't-select', type: 'hidden', name: 'select', value: 'true' }) : null,
    common.omitName ? _react2.default.createElement('input', { type: 'hidden', name: 'omitName', value: common.omitName }) : null
  );
}

HiddenInputs.propTypes = {
  common: _react.PropTypes.object.isRequired,
  isGetRequest: _react.PropTypes.bool,
  noUserType: _react.PropTypes.bool,
  noPosition: _react.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
})(HiddenInputs);

});
},{"174":174,"8":8}],168:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InputGroup(_ref) {
  var icon = _ref.icon,
      children = _ref.children;

  if (!icon) return _react2.default.createElement(
    "div",
    null,
    children
  );
  return _react2.default.createElement(
    "div",
    { className: "tes-input-group" },
    _react2.default.createElement(
      "span",
      { className: "tes-input-group__addon" },
      _react2.default.createElement("i", { className: "icon icon-" + icon })
    ),
    children
  );
}

InputGroup.propTypes = {
  icon: _react.PropTypes.string
};

function InputField(_ref2) {
  var errorClass = _ref2.errorClass,
      errorMessage = _ref2.errorMessage,
      label = _ref2.label,
      value = _ref2.value,
      name = _ref2.name,
      onChange = _ref2.onChange,
      type = _ref2.type,
      icon = _ref2.icon,
      autoFocus = _ref2.autoFocus,
      autoComplete = _ref2.autoComplete;

  var id = "auth-" + name;
  var widgetType = type || 'text';
  return _react2.default.createElement(
    "div",
    { className: errorClass },
    _react2.default.createElement(
      InputGroup,
      { icon: icon },
      _react2.default.createElement(
        "label",
        { className: "tes-control-label tes-control-label--hidden", htmlFor: id },
        label
      ),
      _react2.default.createElement("input", { onChange: onChange, id: id, type: widgetType,
        name: name,
        placeholder: label,
        className: "tes-control tes-input-group__control-last",
        value: value,
        autoFocus: autoFocus,
        autoComplete: autoComplete
      })
    ),
    _react2.default.createElement(
      "div",
      { className: "tes-help-block" },
      errorMessage
    )
  );
}

InputField.propTypes = {
  errorClass: _react.PropTypes.string.isRequired,
  errorMessage: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string.isRequired,
  icon: _react.PropTypes.string,
  value: _react.PropTypes.string.isRequired,
  name: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string,
  onChange: _react.PropTypes.func.isRequired,
  autoFocus: _react.PropTypes.string,
  autoComplete: _react.PropTypes.string
};

exports.default = InputField;

});
},{"8":8}],169:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetLink = WidgetLink;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(176);

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WidgetLink(_ref) {
  var common = _ref.common,
      formType = _ref.formType,
      children = _ref.children,
      actions = _ref.actions;

  var registerPages = {
    signIn: 'sign-in',
    forgotPassword: 'forgot-password',
    register: common.doSelectUserType ? 'select' : 'register'
  };

  var registerPage = registerPages[formType];

  var switchTo = function switchTo(e) {
    if (!common.isModal && !common.isInline) return;
    e.preventDefault();
    actions.initSetFormType(registerPage);
  };

  var encodedRtn = encodeURIComponent(common.rtn);
  var encodedRegUrl = encodeURIComponent(common.regUrl);

  var qs = [];
  if (common.rtn) {
    qs.push('rtn=' + encodedRtn);
  }
  if (common.doSelectUserType) {
    qs.push('select=true');
  }
  if ('id' in common.overrideMz) {
    qs.push('pageId=' + common.overrideMz.id);
  }
  if ('type' in common.overrideMz) {
    qs.push('pageType=' + common.overrideMz.type);
  }
  if ('section' in common.overrideMz) {
    qs.push('pageSection=' + common.overrideMz.section);
  }
  if ('subsection' in common.overrideMz) {
    qs.push('pageSubSection=' + common.overrideMz.subsection);
  }
  if (common.regUrl) {
    qs.push('regUrl=' + encodedRegUrl);
  }
  if (common.omitName) {
    qs.push('omitName=' + common.omitName);
  }

  var baseURLs = {
    signIn: '/authn/sign-in',
    forgotPassword: '/authn/forgot-password',
    register: '/authn/' + registerPage
  };

  var baseURL = baseURLs[formType];
  var url = qs.length ? baseURL + '?' + qs.join('&') : baseURL;
  var extraClass = formType === 'forgotPassword' ? ' pull-right' : '';
  return _react2.default.createElement(
    'a',
    { onClick: switchTo, href: url, className: 't-switch-form link link--colored' + extraClass },
    children
  );
}

WidgetLink.propTypes = {
  common: _react.PropTypes.object.isRequired,
  actions: _react.PropTypes.object.isRequired,
  formType: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
}, mapDispatchToProps)(WidgetLink);

});
},{"176":176,"8":8}],170:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require(26);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _promise = require(18);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require(11);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require(25);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _reqwest = require(154);

var _reqwest2 = _interopRequireDefault(_reqwest);

var _retry = require(2);

var _retry2 = _interopRequireDefault(_retry);

var _memoize = require(1);

var _memoize2 = _interopRequireDefault(_memoize);

var _es6PromisePolyfill = require(130);

var _es6PromisePolyfill2 = _interopRequireDefault(_es6PromisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */
try {
  window.Promise = _es6PromisePolyfill2.default.Promise;
} catch (e) {
  // nothing
}

var getOrigin = function getOrigin() {
  if (window.location.origin) {
    return window.location.origin;
  }
  var port = window.location.port ? ':' + window.location.port : '';
  var protocol = window.location.protocol;
  var hostname = window.location.hostname;
  return protocol + '//' + hostname + port;
};

var XHRTIMEOUT_WITH_RETRY = 9000;
var XHRTIMEOUT_WITHOUT_RETRY = 20000;

var defaultParams = {
  type: 'json',
  contentType: 'application/json',
  headers: {
    accept: 'application/json',
    'x-auth-api-version': '2'
  }
};

function postRequest(endpoint, data, times) {
  var requestFunction = void 0;
  var timeout = void 0;
  if (times) {
    var t0 = new Date();
    var retry = (0, _retry2.default)(times, 100, function (err) {
      return err && err.status === 0;
    }, function () {
      return function (t, o) {
        var t1 = new Date();
        console.log('app-authentication: api trying ' + o.times + ' after ' + (t1 - t0) + ' ms');
      };
    });
    requestFunction = retry(_reqwest2.default);
    timeout = XHRTIMEOUT_WITH_RETRY;
  } else {
    requestFunction = _reqwest2.default;
    timeout = XHRTIMEOUT_WITHOUT_RETRY;
  }

  var _ref = document.cookie.match(/csrf=([^;]*)/) || [],
      _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      match = _ref2[0],
      csrfToken = _ref2[1];

  return requestFunction((0, _assign2.default)({}, defaultParams, {
    url: endpoint,
    method: 'POST',
    timeout: timeout,
    data: (0, _stringify2.default)(data),
    headers: (0, _assign2.default)({}, defaultParams.headers, match && csrfToken ? {
      'x-csrf-token': match && csrfToken
    } : {})
  }));
}

var memoize = (0, _memoize2.default)(function (d) {
  try {
    return d.data.email ? d.data.email : null;
  } catch (e) {
    return null;
  }
});
var cachedReqwest = memoize(_reqwest2.default);

function getRequest(endpoint, data) {
  var timeout = XHRTIMEOUT_WITHOUT_RETRY;

  return cachedReqwest((0, _assign2.default)({}, defaultParams, {
    url: endpoint,
    method: 'GET',
    timeout: timeout,
    data: data
  }));
}

var events = function getEvents() {
  try {
    return window.TES.events;
  } catch (e) {
    return {
      on: function on() {},
      trigger: function trigger() {}
    };
  }
}();

var api = {
  verifyUsername: function verifyUsername(username) {
    return getRequest('/api/authn/find-user', { username: username });
  },
  verifyEmail: function verifyEmail(email) {
    return getRequest('/api/authn/find-user', { email: email });
  },
  signIn: function signIn(data) {
    return postRequest('/api/authn/sign-in-redirect', data, 4);
  },
  register: function register(data) {
    return postRequest('/api/authn/register-redirect', data);
  },
  googleSignIn: function googleSignIn(data) {
    return new _promise2.default(function (resolve, reject) {
      var params = (0, _keys2.default)(data).filter(function (k) {
        return !!data[k];
      }).map(function (k) {
        return [k, encodeURIComponent(data[k])];
      }).map(function (t) {
        return t[0] + '=' + t[1];
      }).join('&');

      var path = '/oauth/google?' + params;

      if (!data.isModal) {
        return window.location.assign(path);
      }

      var done = false;

      var googlePopup = window.open(path, '', 'location=0,status=0,width=600,height=500');

      function onMessage(evt) {
        var msg = void 0;
        if (evt.origin !== getOrigin()) return;
        try {
          msg = (0, _typeof3.default)(evt.data) === 'object' ? evt.data : JSON.parse(evt.data);
        } catch (e) {
          // ie9 returns evt.data === undefined, but I won't care!!!!
          // this is also the case of non JSON messages
          return;
        }
        if (msg.sender !== 'googlepopup') {
          return;
        }
        if (msg.status === 'ok' || msg.status === 'error') {
          done = true;
          window.removeEventListener('message', onMessage);
          googlePopup.close();
        }
        if (msg.status === 'ok') {
          resolve();
        }
        if (msg.status === 'error') {
          reject(new Error(msg.errorCode));
        }
      }

      window.addEventListener('message', onMessage);

      var _oauthInterval = window.setInterval(function () {
        var fireError = function fireError(errorCode) {
          if (!done) {
            reject(new Error(errorCode));
          }
          window.removeEventListener('message', onMessage);
          window.clearInterval(_oauthInterval);
        };
        try {
          if (!googlePopup) {
            fireError('google.popup.blocked');
          } else if (googlePopup.closed) {
            fireError('google.popup.closed');
          }
        } catch (e) {
          // ie fires error here
        }
      }, 1000);
    });
  },
  forgotPassword: function forgotPassword(data) {
    return postRequest('/api/authn/forgot-password', data);
  },
  updateUserData: function updateUserData(data) {
    return postRequest('/api/authn/edit-account', data);
  },
  reload: function reload(url) {
    if (url) {
      window.location.assign(url);
    } else {
      window.location.reload(true);
    }
  },
  loggedInEvent: function loggedInEvent() {
    events.trigger('logged-in');
  },
  closeModalEvent: function closeModalEvent() {
    events.trigger('modal-close', 'authapp');
  }
};

exports.default = api;

});
},{"1":1,"11":11,"12":12,"130":130,"154":154,"16":16,"18":18,"2":2,"25":25,"26":26,"8":8}],171:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authDenied = authDenied;
exports.forgotPasswordDenied = forgotPasswordDenied;
var bannedStates = {
  2: 'banned',
  3: 'disapproved',
  4: 'possible spam activity',
  5: 'locked out'
};

function getResponse(err) {
  if ('response' in err || 'responseText' in err) {
    try {
      return JSON.parse(err.response || err.responseText);
    } catch (e) {
      return undefined;
    }
  } else {
    return err;
  }
}

function authDenied(err) {
  if (err.status === 401) {
    return 'signin.unauthorized';
  }
  if (err.status === 403) {
    var response = getResponse(err);
    if (response && 'data' in response && response.data.code && response.data.code in bannedStates) {
      return 'signin.' + bannedStates[response.data.code];
    }
    return 'signin.generic.banned';
  }
}

function forgotPasswordDenied(err) {
  if (err.status === 404) {
    return 'forgot-password.user.not-found';
  }
  if (err.status === 403) {
    var response = getResponse(err);
    if (response && 'data' in response && response.data.code && response.data.code in bannedStates) {
      return 'forgot-password.' + bannedStates[response.data.code];
    }
    return 'forgot-password.generic.banned';
  }
}

});
},{"8":8}],172:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorMsgFromPrefix = getErrorMsgFromPrefix;
exports.getErrorClsFromPrefix = getErrorClsFromPrefix;
function getErrorMsgFromPrefix(prefix) {
  return function (_field) {
    var field = prefix + '.' + _field;
    return function (err) {
      return err && field in err ? err[field].msg : '';
    };
  };
}

function getErrorClsFromPrefix(prefix) {
  return function (_field) {
    var field = prefix + '.' + _field;
    return function (err) {
      return err && field in err && err[field].state === 'error' ? ' tes-has-error' : '';
    };
  };
}

});
},{"8":8}],173:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.careerFinder = careerFinder;
exports.filterPosition = filterPosition;
exports.getUserTypePosition = getUserTypePosition;
function careerFinder(positions, careers, currentPosition) {
  var careerMatch = careers.filter(function (item) {
    return item.name === currentPosition;
  });
  if (careerMatch.length) {
    return { name: careerMatch[0].name, groupLabel: null };
  }
  var positionMatch = positions.filter(function (item) {
    return item.name === currentPosition;
  });
  if (positionMatch.length) {
    var groupLabel = positionMatch[0].groupLabel;
    var groupMatch = careers.filter(function (item) {
      return item.groupLabel === groupLabel;
    });
    if (groupMatch.length) {
      return { name: groupMatch[0].name, groupLabel: groupLabel };
    }
  }
  return { name: '', groupLabel: null };
}

function filterPosition(positions, currentCareerObj) {
  return positions.filter(function (pos) {
    if (currentCareerObj.groupLabel) {
      return pos.groupLabel === currentCareerObj.groupLabel;
    }
    return pos.name === currentCareerObj.name;
  });
}

function getUserTypePosition(positions, currentPosition) {
  // const posObj = positions.find((pos) => pos.name === currentPosition);
  var posIndex = positions.map(function (pos) {
    return pos.name === currentPosition;
  }).indexOf(true);
  var posObj = positions[posIndex];
  return posObj ? posObj.userType : 'other';
}

});
},{"8":8}],174:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackClick = trackClick;
exports.trackDisplay = trackDisplay;
exports.trackError = trackError;
exports.trackForgotPassword = trackForgotPassword;
exports.trackLogin = trackLogin;
exports.trackRegister = trackRegister;
exports.getTrackingType = getTrackingType;
exports.getPageContext = getPageContext;
/* global _mz:false, _mze:false */

function hasMz() {
  try {
    return !!_mz;
  } catch (e) {
    return false;
  }
}

function trackClick(formType) {
  if (!hasMz()) return;
  var eventTitle = void 0;
  if (formType === 'sign-in') {
    eventTitle = 'login';
  } else if (formType === 'register' || formType === 'select') {
    eventTitle = 'register';
  }
  if (eventTitle) {
    _mz.emit(_mze.CLICK, {
      module: {
        type: 'auth-links'
      },
      eventTitle: eventTitle
    });
  }
}

function trackDisplay(formType, type, userType, doSelectUserType) {
  if (!hasMz()) return;
  var eventTitle = {
    'sign-in': 'tes-login',
    register: 'register',
    'forgot-password': 'forgot-password',
    select: 'tes-account-type'
  };
  var event = {
    id: eventTitle[formType] || 'tes-login',
    module: {
      id: doSelectUserType ? 'useSelect' : null,
      type: type
    }
  };

  if (formType === 'select') {
    event.variant = 'position-selector';
  } else if (userType) {
    event.variant = userType;
  }

  _mz.emit(_mze.DISPLAY, event);
}

function trackError(id, msg, type) {
  if (!hasMz()) return;
  var evt = id === 'register-fail' ? _mze.REGISTER_FAIL : _mze.LOGIN_FAIL;
  _mz.emit(evt, {
    id: id,
    payload: {
      message: msg
    },
    module: {
      type: type
    }
  });
}

function trackForgotPassword(type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.SUBMIT, {
    id: 'forgot-password',
    module: {
      type: type
    }
  }, cb);
}

function trackLogin(id, type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.LOGIN, {
    id: id,
    module: {
      type: type
    }
  }, cb);
}

function trackRegister(type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.REGISTER, {
    id: 'register',
    module: {
      type: type
    },
    tags: ['funnel']
  }, cb);
}

function getTrackingType(isModal, isInline) {
  if (isModal) {
    return 'modal';
  } else if (isInline) {
    return 'embed';
  }
  return 'standalone';
}

function getPageContext(pageMetadata, overridePageMetadata) {
  var meta = {};

  if ('id' in overridePageMetadata || 'id' in pageMetadata) {
    meta.pageId = overridePageMetadata.id || pageMetadata.id;
  }

  if ('type' in overridePageMetadata || 'type' in pageMetadata) {
    meta.pageType = overridePageMetadata.type || pageMetadata.type;
  }

  if ('section' in overridePageMetadata || 'section' in pageMetadata) {
    meta.pageSection = overridePageMetadata.section || pageMetadata.section;
  }

  if ('subsection' in overridePageMetadata || 'subsection' in pageMetadata) {
    meta.pageSubSection = overridePageMetadata.subsection || pageMetadata.subsection;
  }

  return meta;
}

});
},{"8":8}],175:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require(26);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = traverseObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function traverseObject(obj, key) {
  if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
    return undefined;
  }
  for (var k in obj) {
    if (key === k) {
      return obj[key];
    }
    var value = traverseObject(obj[k], key);
    if (value) {
      return value;
    }
  }
  return undefined;
}

});
},{"26":26,"8":8}],176:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = reset;
exports.initSetFormType = initSetFormType;
exports.setFormType = setFormType;
exports.setPosition = setPosition;
exports.updateUserData = updateUserData;
exports.validationErrors = validationErrors;
exports.setUserType = setUserType;
exports.successGoogleSignIn = successGoogleSignIn;
exports.successSignIn = successSignIn;
exports.successRegister = successRegister;
exports.failSignIn = failSignIn;
exports.failRegister = failRegister;
exports.failForgotPassword = failForgotPassword;
exports.failGoogleSignIn = failGoogleSignIn;
exports.initSignIn = initSignIn;
exports.initRegister = initRegister;
exports.initGoogleSignIn = initGoogleSignIn;
exports.initForgotPassword = initForgotPassword;
exports.sentForgotPassword = sentForgotPassword;
exports.successForgotPassword = successForgotPassword;
exports.validateField = validateField;
exports.changeField = changeField;
exports.setField = setField;
exports.resetErrors = resetErrors;
exports.suggestUserName = suggestUserName;
exports.trackClick = trackClick;
exports.trackDisplay = trackDisplay;

var _constants = require(177);

var constant = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Action Creators
function reset() {
  return { type: constant.RESET };
}

function initSetFormType(formType) {
  return { type: constant.INIT_SET_FORM_TYPE, formType: formType };
}

function setFormType(formType) {
  return { type: constant.SET_FORM_TYPE, formType: formType };
}

function setPosition(position, userType) {
  return { type: constant.SET_POSITION, position: position, userType: userType };
}

function updateUserData(data) {
  return { type: constant.UPDATE_USER_DATA, data: data };
}

function validationErrors(errors) {
  return { type: constant.VALIDATION_ERRORS, errors: errors };
}

function setUserType(userType) {
  return { type: constant.SET_USER_TYPE, userType: userType };
}

function successGoogleSignIn() {
  return { type: constant.SUCCESS_GOOGLE_SIGN_IN };
}

function successSignIn() {
  return { type: constant.SUCCESS_SIGN_IN };
}

function successRegister() {
  return { type: constant.SUCCESS_REGISTER };
}

function failSignIn(errors) {
  return { type: constant.FAIL_SIGN_IN, errors: errors };
}

function failRegister(errors) {
  return { type: constant.FAIL_REGISTER, errors: errors };
}

function failForgotPassword(errors) {
  return { type: constant.FAIL_FORGOT_PASSWORD, errors: errors };
}

function failGoogleSignIn(errors) {
  return { type: constant.FAIL_GOOGLE_SIGN_IN, errors: errors };
}

function initSignIn(callback) {
  return { type: constant.INIT_SIGN_IN, callback: callback };
}

function initRegister(callback) {
  return { type: constant.INIT_REGISTER, callback: callback };
}

function initGoogleSignIn() {
  return { type: constant.INIT_GOOGLE_SIGN_IN };
}

function initForgotPassword() {
  return { type: constant.INIT_FORGOT_PASSWORD };
}

function sentForgotPassword() {
  return { type: constant.SENT_FORGOT_PASSWORD };
}

function successForgotPassword() {
  return { type: constant.SUCCESS_FORGOT_PASSWORD };
}

function validateField(name) {
  return { type: constant.VALIDATE_FIELD, name: name };
}

function changeField(name, deps) {
  return { type: constant.CHANGE_FIELD, name: name, deps: deps };
}

function setField(form, name, value) {
  return { type: constant.SET_FIELD, form: form, name: name, value: value };
}

function resetErrors() {
  return { type: constant.RESET_ERRORS };
}

function suggestUserName(username) {
  return { type: constant.SUGGEST_USER_NAME, username: username };
}

function trackClick(formType) {
  return { type: constant.TRACK_CLICK, formType: formType };
}

function trackDisplay(formType) {
  return { type: constant.TRACK_DISPLAY, formType: formType };
}

});
},{"177":177,"8":8}],177:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESET = exports.RESET = 'RESET';
var INIT_SET_FORM_TYPE = exports.INIT_SET_FORM_TYPE = 'INIT_SET_FORM_TYPE';
var SET_FORM_TYPE = exports.SET_FORM_TYPE = 'SET_FORM_TYPE';
var SET_USER_TYPE = exports.SET_USER_TYPE = 'SET_USER_TYPE';
var SET_POSITION = exports.SET_POSITION = 'SET_POSITION';
var UPDATE_USER_DATA = exports.UPDATE_USER_DATA = 'UPDATE_USER_DATA';

var VALIDATION_ERRORS = exports.VALIDATION_ERRORS = 'VALIDATION_ERRORS';

var SUCCESS_GOOGLE_SIGN_IN = exports.SUCCESS_GOOGLE_SIGN_IN = 'SUCCESS_GOOGLE_SIGN_IN';
var SUCCESS_SIGN_IN = exports.SUCCESS_SIGN_IN = 'SUCCESS_SIGN_IN';
var SUCCESS_REGISTER = exports.SUCCESS_REGISTER = 'SUCCESS_REGISTER';
var SUCCESS_FORGOT_PASSWORD = exports.SUCCESS_FORGOT_PASSWORD = 'SUCCESS_FORGOT_PASSWORD';

var INIT_SIGN_IN = exports.INIT_SIGN_IN = 'INIT_SIGN_IN';
var INIT_REGISTER = exports.INIT_REGISTER = 'INIT_REGISTER';
var INIT_GOOGLE_SIGN_IN = exports.INIT_GOOGLE_SIGN_IN = 'INIT_GOOGLE_SIGN_IN';

var FAIL_SIGN_IN = exports.FAIL_SIGN_IN = 'FAIL_SIGN_IN';
var FAIL_REGISTER = exports.FAIL_REGISTER = 'FAIL_REGISTER';
var FAIL_FORGOT_PASSWORD = exports.FAIL_FORGOT_PASSWORD = 'FAIL_FORGOT_PASSWORD';
var FAIL_GOOGLE_SIGN_IN = exports.FAIL_GOOGLE_SIGN_IN = 'FAIL_GOOGLE_SIGN_IN';

var INIT_FORGOT_PASSWORD = exports.INIT_FORGOT_PASSWORD = 'INIT_FORGOT_PASSWORD';
var SENT_FORGOT_PASSWORD = exports.SENT_FORGOT_PASSWORD = 'SENT_FORGOT_PASSWORD';

var VALIDATE_FIELD = exports.VALIDATE_FIELD = 'VALIDATE_FIELD';
var CHANGE_FIELD = exports.CHANGE_FIELD = 'CHANGE_FIELD';
var SET_FIELD = exports.SET_FIELD = 'SET_FIELD';

var RESET_ERRORS = exports.RESET_ERRORS = 'RESET_ERRORS';
var SUGGEST_USER_NAME = exports.SUGGEST_USER_NAME = 'SUGGEST_USER_NAME';

var TRACK_DISPLAY = exports.TRACK_DISPLAY = 'TRACK_DISPLAY';
var TRACK_CLICK = exports.TRACK_CLICK = 'TRACK_CLICK';

});
},{"8":8}],178:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

exports.default = reducer;

var _constants = require(177);

var constant = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  common: {},
  register: {
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    newsletter: false,
    autoFillUsername: true,
    state: null
  },
  signIn: {
    identification: '',
    password: '',
    trustedComputer: false,
    state: null
  },
  forgotPassword: {
    identification: '',
    state: null
  },
  errors: {}
};

function extend(state, obj) {
  var s = {};
  (0, _keys2.default)(obj).forEach(function (attr) {
    s[attr] = (0, _assign2.default)({}, state[attr], obj[attr]);
  });
  return (0, _assign2.default)({}, state, s);
}

// Reducer
function reset(state) {
  var newState = {
    errors: {},
    common: (0, _assign2.default)({}, state.common, { googleState: null }),
    register: initialState.register,
    signIn: initialState.signIn,
    forgotPassword: initialState.forgotPassword
  };
  newState.signIn.trustedComputer = state.common.isMobile;
  return (0, _assign2.default)({}, state, newState);
}

function resetErrors(state) {
  return (0, _assign2.default)({}, state, { errors: {} });
}

function setFormType(state, action) {
  return extend(state, { common: { formType: action.formType } });
}

function setUserType(state, action) {
  return extend(state, { common: { userType: action.userType } });
}

function setPosition(state, action) {
  return extend(state, { common: { userType: action.userType, position: action.position } });
}

function validationErrors(state, action) {
  return extend(state, { errors: action.errors });
}

function initSignIn(state) {
  return extend(resetErrors(state), { signIn: { state: 'wait' } });
}

function initRegister(state) {
  return extend(resetErrors(state), { register: { state: 'wait' } });
}

function initGoogleSignIn(state) {
  return extend(resetErrors(state), { common: { googleState: 'wait' } });
}

function initForgotPassword(state) {
  return extend(resetErrors(state), { forgotPassword: { state: 'wait' } });
}

function failSignIn(state) {
  return extend(state, { signIn: { state: null } });
}

function failRegister(state) {
  return extend(state, { register: { state: null } });
}

function failGoogleSignIn(state) {
  return extend(state, { common: { googleState: null } });
}

function failForgotPassword(state) {
  return extend(state, { forgotPassword: { state: null } });
}

function sentForgotPassword(state) {
  return extend(resetErrors(state), { forgotPassword: { state: 'sent' } });
}

function validateField(state, action) {
  if (action.name === 'registration.email' && state.register.username === '') {
    return extend(state, { register: { autoFillUsername: true } });
  }
  if (action.name === 'registration.username') {
    return extend(state, { register: { autoFillUsername: false } });
  }
  return state;
}

function changeField(state, action) {
  var newErrors = (0, _assign2.default)({}, state.errors);
  delete newErrors[action.name];
  action.deps.forEach(function (d) {
    return delete newErrors[d];
  });
  return (0, _assign2.default)({}, state, { errors: newErrors });
}

function setField(state, action) {
  var obj = {};
  obj[action.form] = {};
  obj[action.form][action.name] = action.value;
  if (action.form === 'signIn' && action.name === 'identification') {
    (0, _assign2.default)(obj, { forgotPassword: { identification: action.value } });
  }
  return extend(state, obj);
}

function suggestUserName(state, action) {
  if (!state.register.autoFillUsername) {
    return state;
  }
  var newErrors = (0, _assign2.default)({}, state.errors);
  delete newErrors['registration.username'];
  var newState = (0, _assign2.default)({}, state, { errors: newErrors });
  return extend(newState, { register: { username: action.username } });
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case constant.RESET:
      return reset(state, action);
    case constant.SET_FORM_TYPE:
      return setFormType(state, action);
    case constant.SET_USER_TYPE:
      return setUserType(state, action);
    case constant.SET_POSITION:
      return setPosition(state, action);
    case constant.VALIDATION_ERRORS:
      return validationErrors(state, action);
    case constant.INIT_SIGN_IN:
      return initSignIn(state, action);
    case constant.INIT_REGISTER:
      return initRegister(state, action);
    case constant.INIT_GOOGLE_SIGN_IN:
      return initGoogleSignIn(state, action);
    case constant.INIT_FORGOT_PASSWORD:
      return initForgotPassword(state, action);
    case constant.FAIL_SIGN_IN:
      return failSignIn(state, action);
    case constant.FAIL_REGISTER:
      return failRegister(state, action);
    case constant.FAIL_GOOGLE_SIGN_IN:
      return failGoogleSignIn(state, action);
    case constant.FAIL_FORGOT_PASSWORD:
      return failForgotPassword(state, action);
    case constant.SENT_FORGOT_PASSWORD:
      return sentForgotPassword(state, action);
    case constant.VALIDATE_FIELD:
      return validateField(state, action);
    case constant.CHANGE_FIELD:
      return changeField(state, action);
    case constant.SET_FIELD:
      return setField(state, action);
    case constant.RESET_ERRORS:
      return resetErrors(state, action);
    case constant.SUGGEST_USER_NAME:
      return suggestUserName(state, action);

    default:
      return state;
  }
}

});
},{"12":12,"16":16,"177":177,"8":8}],179:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = require(27);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.initSignIn = initSignIn;
exports.initRegister = initRegister;
exports.initGoogleSignIn = initGoogleSignIn;
exports.initForgotPassword = initForgotPassword;
exports.successSignIn = successSignIn;
exports.successForgotPassword = successForgotPassword;
exports.updateUserData = updateUserData;
exports.validateField = validateField;
exports.suggestUserName = suggestUserName;
exports.initSetFormType = initSetFormType;
exports.failSignIn = failSignIn;
exports.failRegister = failRegister;
exports.trackClickSaga = trackClickSaga;
exports.trackDisplaySaga = trackDisplaySaga;
exports.default = rootSaga;

var _reduxSaga = require(141);

var _effects = require(139);

var _minijoi = require(137);

var _minijoi2 = _interopRequireDefault(_minijoi);

var _deniedErrorcode = require(171);

var _actions = require(176);

var actions = _interopRequireWildcard(_actions);

var _tracking = require(174);

var _traverseObject = require(175);

var _traverseObject2 = _interopRequireDefault(_traverseObject);

var _errorMessages = require(156);

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _constants = require(177);

var constant = _interopRequireWildcard(_constants);

var _api = require(170);

var _api2 = _interopRequireDefault(_api);

var _utils = require(180);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [initSignIn, initRegister, initGoogleSignIn, initForgotPassword, successSignIn, successForgotPassword, updateUserData, validateField, suggestUserName, initSetFormType, failSignIn, failRegister, trackClickSaga, trackDisplaySaga, takeLatestWithName, rootSaga].map(_regenerator2.default.mark);

/*
  utilities
*/
function getWindow() {
  try {
    return window;
  } catch (e) {
    return {};
  }
}

function getErrorCode(xhr, prefix) {
  var genericErrorCode = xhr.status >= 400 && xhr.status < 500 ? 'denied' : 'generic';
  try {
    var response = JSON.parse(xhr.response || xhr.responseText);
    // assembling the error code
    var errorCodes = response.errors.map(function (e) {
      return prefix + '.' + e.field + '.' + e.types[0];
    });
    return errorCodes.length ? errorCodes.join(',') : prefix + '.' + genericErrorCode + '.error';
  } catch (e) {
    if (getWindow()._airbrake) {
      var errorObj = void 0;
      if (xhr.status === 0) {
        errorObj = { error: { message: 'app-authentication: api timing out (' + prefix + ') readystate ' + xhr.readyState, fileName: 'restapi.js', lineNumber: 0, columnNumber: 0 } };
      } else {
        errorObj = { error: { message: 'app-authentication: api returning unexpected ' + genericErrorCode + ' (' + prefix + '): ' + xhr.status + ' - ' + xhr.response, fileName: 'api.js', lineNumber: 0, columnNumber: 0 } };
      }
      getWindow()._airbrake.push(errorObj);
    }
    return prefix + '.' + genericErrorCode + '.error';
  }
}

var userNameValidation = _minijoi2.default.string().min(3).max(30).regex(/^[A-Za-z0-9_\-]*$/).required();
var emailValidation = _minijoi2.default.string().email();

// const schemas = {
//   registration: Joi.object().keys({
//     username: userNameValidation,
//     email: emailValidation,
//     password: Joi.string().min(6).required(),
//     firstName: Joi.string(),
//     lastName: Joi.string(),
//     newsletter: Joi.boolean(),
//   }),
// };

/*
  sagas
*/
function initSignIn(action) {
  var isInline, isModal, credentials, errorCode, errors;
  return _regenerator2.default.wrap(function initSignIn$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context.sent;
          _context.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context.sent;

          if (!(!isInline && !isModal)) {
            _context.next = 20;
            break;
          }

          _context.prev = 9;
          _context.next = 12;
          return (0, _effects.cps)(_tracking.trackLogin, 'tes-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 12:
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](9);

          console.log('Tracking Login error', _context.t0.message); // eslint-disable-line no-console

        case 17:
          _context.next = 19;
          return (0, _effects.call)(action.callback);

        case 19:
          return _context.abrupt('return');

        case 20:
          _context.prev = 20;
          _context.next = 23;
          return (0, _effects.call)(_tracking.trackLogin, 'tes-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 23:
          _context.next = 25;
          return (0, _effects.select)(_utils.getSignInData);

        case 25:
          credentials = _context.sent;
          _context.next = 28;
          return (0, _effects.call)(_api2.default.signIn, credentials);

        case 28:
          _context.next = 30;
          return (0, _effects.put)(actions.successSignIn());

        case 30:
          _context.next = 40;
          break;

        case 32:
          _context.prev = 32;
          _context.t1 = _context['catch'](20);
          errorCode = (0, _deniedErrorcode.authDenied)(_context.t1) || getErrorCode(_context.t1, 'signin');
          errors = (0, _errorMessages2.default)(errorCode);
          _context.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context.next = 40;
          return (0, _effects.put)(actions.failSignIn(errors));

        case 40:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[9, 14], [20, 32]]);
}

function initRegister(action) {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initRegister$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context2.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context2.sent;
          _context2.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context2.sent;

          if (!(!isInline && !isModal)) {
            _context2.next = 20;
            break;
          }

          _context2.prev = 9;
          _context2.next = 12;
          return (0, _effects.cps)(_tracking.trackRegister, (0, _tracking.getTrackingType)(isModal, isInline));

        case 12:
          _context2.next = 17;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2['catch'](9);

          console.log('Tracking Registration error', _context2.t0.message); // eslint-disable-line no-console

        case 17:
          _context2.next = 19;
          return (0, _effects.call)(action.callback);

        case 19:
          return _context2.abrupt('return');

        case 20:
          _context2.prev = 20;
          _context2.next = 23;
          return (0, _effects.call)(_tracking.trackRegister, (0, _tracking.getTrackingType)(isModal, isInline));

        case 23:
          _context2.next = 25;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 25:
          info = _context2.sent;
          _context2.next = 28;
          return (0, _effects.call)(_api2.default.register, info);

        case 28:
          _context2.next = 30;
          return (0, _effects.put)(actions.successRegister());

        case 30:
          _context2.next = 40;
          break;

        case 32:
          _context2.prev = 32;
          _context2.t1 = _context2['catch'](20);
          errorCode = getErrorCode(_context2.t1, 'registration');
          errors = (0, _errorMessages2.default)(errorCode);
          _context2.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context2.next = 40;
          return (0, _effects.put)(actions.failRegister(errors));

        case 40:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[9, 14], [20, 32]]);
}

function initGoogleSignIn() {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initGoogleSignIn$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)(actions.resetErrors());

        case 3:
          _context3.next = 5;
          return (0, _effects.select)(_utils.getIsInline);

        case 5:
          isInline = _context3.sent;
          _context3.next = 8;
          return (0, _effects.select)(_utils.getIsModal);

        case 8:
          isModal = _context3.sent;
          _context3.next = 11;
          return (0, _effects.select)(_utils.getGoogleSignInData);

        case 11:
          info = _context3.sent;

          if (!(!isModal && !isInline)) {
            _context3.next = 24;
            break;
          }

          _context3.prev = 13;
          _context3.next = 16;
          return (0, _effects.cps)(_tracking.trackLogin, 'google-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 16:
          _context3.next = 21;
          break;

        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3['catch'](13);

          console.log('Tracking Google Login error', _context3.t0.message); // eslint-disable-line no-console

        case 21:
          _context3.next = 23;
          return (0, _effects.call)(_api2.default.googleSignIn, info);

        case 23:
          return _context3.abrupt('return');

        case 24:
          _context3.next = 26;
          return (0, _effects.call)(_tracking.trackLogin, 'google-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 26:
          _context3.next = 28;
          return (0, _effects.call)(_api2.default.googleSignIn, info);

        case 28:
          _context3.next = 30;
          return (0, _effects.put)(actions.successGoogleSignIn());

        case 30:
          _context3.next = 40;
          break;

        case 32:
          _context3.prev = 32;
          _context3.t1 = _context3['catch'](0);
          errorCode = _context3.t1.message;
          errors = (0, _errorMessages2.default)(errorCode);
          _context3.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context3.next = 40;
          return (0, _effects.put)(actions.failGoogleSignIn(errors));

        case 40:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 32], [13, 18]]);
}

function initForgotPassword() {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initForgotPassword$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context4.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context4.sent;
          _context4.prev = 8;
          _context4.next = 11;
          return (0, _effects.cps)(_tracking.trackForgotPassword, (0, _tracking.getTrackingType)(isModal, isInline));

        case 11:
          _context4.next = 16;
          break;

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4['catch'](8);

          console.log('Tracking forgot password error', _context4.t0.message); // eslint-disable-line no-console

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.select)(_utils.getForgotPasswordData);

        case 19:
          info = _context4.sent;
          _context4.next = 22;
          return (0, _effects.call)(_api2.default.forgotPassword, info);

        case 22:
          _context4.next = 24;
          return (0, _effects.put)(actions.sentForgotPassword());

        case 24:
          _context4.next = 26;
          return (0, _effects.put)(actions.setField('forgotPassword', 'identification', ''));

        case 26:
          _context4.next = 36;
          break;

        case 28:
          _context4.prev = 28;
          _context4.t1 = _context4['catch'](16);
          errorCode = (0, _deniedErrorcode.forgotPasswordDenied)(_context4.t1) || getErrorCode(_context4.t1, 'forgot-password');
          errors = (0, _errorMessages2.default)(errorCode);
          _context4.next = 34;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 34:
          _context4.next = 36;
          return (0, _effects.put)(actions.failForgotPassword(errors));

        case 36:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[8, 13], [16, 28]]);
}

function successSignIn() {
  var onSuccess, reloadURL;
  return _regenerator2.default.wrap(function successSignIn$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(_utils.getOnSuccess);

        case 2:
          onSuccess = _context5.sent;

          if (!(onSuccess === 'reload')) {
            _context5.next = 11;
            break;
          }

          _context5.next = 6;
          return (0, _effects.select)(_utils.getReloadURL);

        case 6:
          reloadURL = _context5.sent;
          _context5.next = 9;
          return (0, _effects.call)(_api2.default.reload, reloadURL);

        case 9:
          _context5.next = 19;
          break;

        case 11:
          _context5.next = 13;
          return (0, _effects.call)(_api2.default.closeModalEvent);

        case 13:
          _context5.next = 15;
          return (0, _effects.call)(_api2.default.loggedInEvent);

        case 15:
          _context5.next = 17;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 17:
          _context5.next = 19;
          return (0, _effects.put)(actions.reset());

        case 19:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function successForgotPassword() {
  return _regenerator2.default.wrap(function successForgotPassword$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actions.setField('forgotPassword', 'identification', ''));

        case 2:
          _context6.next = 4;
          return (0, _effects.call)(_api2.default.closeModalEvent);

        case 4:
          _context6.next = 6;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 6:
          _context6.next = 8;
          return (0, _effects.put)(actions.reset());

        case 8:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function updateUserData(action) {
  var errorCode;
  return _regenerator2.default.wrap(function updateUserData$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_api2.default.updateUserData, action.data);

        case 3:
          _context7.next = 5;
          return (0, _effects.put)(actions.successSignIn());

        case 5:
          _context7.next = 12;
          break;

        case 7:
          _context7.prev = 7;
          _context7.t0 = _context7['catch'](0);
          errorCode = getErrorCode(_context7.t0, 'edit-account');
          _context7.next = 12;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)(errorCode)));

        case 12:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[0, 7]]);
}

function validateField(action) {
  var userData, response, _response;

  return _regenerator2.default.wrap(function validateField$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.call)(_reduxSaga.delay, 1200);

        case 2:
          _context8.next = 4;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 4:
          userData = _context8.sent;
          _context8.prev = 5;

          if (!(action.name === 'registration.username' && userData.username && !_minijoi2.default.validate(userData.username, userNameValidation).error)) {
            _context8.next = 15;
            break;
          }

          _context8.next = 9;
          return (0, _effects.call)(_api2.default.verifyUsername, userData.username);

        case 9:
          response = _context8.sent;

          if (!response.length) {
            _context8.next = 13;
            break;
          }

          _context8.next = 13;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)('registration.username.duplicate')));

        case 13:
          _context8.next = 25;
          break;

        case 15:
          if (!(action.name === 'registration.email' && userData.email && !_minijoi2.default.validate(userData.email, emailValidation).error)) {
            _context8.next = 25;
            break;
          }

          _context8.next = 18;
          return (0, _effects.call)(_api2.default.verifyEmail, userData.email);

        case 18:
          _response = _context8.sent;

          if (!_response.length) {
            _context8.next = 22;
            break;
          }

          _context8.next = 22;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)('registration.email.duplicate')));

        case 22:
          if (!_response.suggestedUsername) {
            _context8.next = 25;
            break;
          }

          _context8.next = 25;
          return (0, _effects.put)(actions.suggestUserName(_response.suggestedUsername));

        case 25:
          _context8.next = 30;
          break;

        case 27:
          _context8.prev = 27;
          _context8.t0 = _context8['catch'](5);

          console.log('Error validate field', action.name, _context8.t0.message); // eslint-disable-line no-console

        case 30:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[5, 27]]);
}

function suggestUserName() {
  var userData, response;
  return _regenerator2.default.wrap(function suggestUserName$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 2:
          userData = _context9.sent;
          _context9.prev = 3;

          if (!(userData.email && !_minijoi2.default.validate(userData.email, emailValidation).error)) {
            _context9.next = 11;
            break;
          }

          _context9.next = 7;
          return (0, _effects.call)(_api2.default.verifyEmail, userData.email);

        case 7:
          response = _context9.sent;

          if (!response.suggestedUsername) {
            _context9.next = 11;
            break;
          }

          _context9.next = 11;
          return (0, _effects.put)(actions.suggestUserName(response.suggestedUsername));

        case 11:
          _context9.next = 16;
          break;

        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9['catch'](3);

          console.log('Error suggest username', _context9.t0.message); // eslint-disable-line no-console

        case 16:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[3, 13]]);
}

function initSetFormType(action) {
  var isInline, isModal, oldFormType;
  return _regenerator2.default.wrap(function initSetFormType$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.select)(_utils.getIsInline);

        case 2:
          isInline = _context10.sent;
          _context10.next = 5;
          return (0, _effects.select)(_utils.getIsModal);

        case 5:
          isModal = _context10.sent;

          if (!(!isModal && !isInline)) {
            _context10.next = 8;
            break;
          }

          return _context10.abrupt('return');

        case 8:
          _context10.next = 10;
          return (0, _effects.select)(_utils.getFormType);

        case 10:
          oldFormType = _context10.sent;

          if (!(oldFormType === action.formType)) {
            _context10.next = 13;
            break;
          }

          return _context10.abrupt('return');

        case 13:
          _context10.next = 15;
          return (0, _effects.put)(actions.setFormType(action.formType));

        case 15:
          _context10.next = 17;
          return (0, _effects.put)(actions.trackClick(action.formType));

        case 17:
          _context10.next = 19;
          return (0, _effects.put)(actions.trackDisplay(action.formType));

        case 19:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function failSignIn(action) {
  var filteredErrors, msg, id, isInline, isModal;
  return _regenerator2.default.wrap(function failSignIn$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          if (action.errors) {
            _context11.next = 2;
            break;
          }

          return _context11.abrupt('return');

        case 2:
          filteredErrors = (0, _keys2.default)(action.errors).filter(function (e) {
            return e.startsWith('signin.') || e.startsWith('generic.googlebutton');
          });

          if (!filteredErrors.length) {
            _context11.next = 14;
            break;
          }

          msg = (0, _traverseObject2.default)(action.errors[filteredErrors[0]], 'msg') || 'unknown error';
          id = filteredErrors[0] === 'generic.googlebutton' ? 'google-login-fail' : 'login-fail';
          _context11.next = 8;
          return (0, _effects.select)(_utils.getIsInline);

        case 8:
          isInline = _context11.sent;
          _context11.next = 11;
          return (0, _effects.select)(_utils.getIsModal);

        case 11:
          isModal = _context11.sent;
          _context11.next = 14;
          return (0, _effects.call)(_tracking.trackError, id, msg, (0, _tracking.getTrackingType)(isModal, isInline));

        case 14:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function failRegister(action) {
  var filteredErrors, msg, isInline, isModal;
  return _regenerator2.default.wrap(function failRegister$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          if (action.errors) {
            _context12.next = 2;
            break;
          }

          return _context12.abrupt('return');

        case 2:
          filteredErrors = (0, _keys2.default)(action.errors).filter(function (e) {
            return e.startsWith('registration.');
          });

          if (!filteredErrors.length) {
            _context12.next = 13;
            break;
          }

          msg = (0, _traverseObject2.default)(action.errors[filteredErrors[0]], 'msg') || 'unknown error';
          _context12.next = 7;
          return (0, _effects.select)(_utils.getIsInline);

        case 7:
          isInline = _context12.sent;
          _context12.next = 10;
          return (0, _effects.select)(_utils.getIsModal);

        case 10:
          isModal = _context12.sent;
          _context12.next = 13;
          return (0, _effects.call)(_tracking.trackError, 'register-fail', msg, (0, _tracking.getTrackingType)(isModal, isInline));

        case 13:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function trackClickSaga(action) {
  return _regenerator2.default.wrap(function trackClickSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.call)(_tracking.trackClick, action.formType);

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function trackDisplaySaga(action) {
  var isInline, isModal, userType, doSelectUserType;
  return _regenerator2.default.wrap(function trackDisplaySaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.select)(_utils.getIsInline);

        case 2:
          isInline = _context14.sent;
          _context14.next = 5;
          return (0, _effects.select)(_utils.getIsModal);

        case 5:
          isModal = _context14.sent;
          _context14.next = 8;
          return (0, _effects.select)(_utils.getUserType);

        case 8:
          userType = _context14.sent;
          _context14.next = 11;
          return (0, _effects.select)(_utils.getDoSelectUserType);

        case 11:
          doSelectUserType = _context14.sent;

          if (isInline) {
            _context14.next = 15;
            break;
          }

          _context14.next = 15;
          return (0, _effects.call)(_tracking.trackDisplay, action.formType, (0, _tracking.getTrackingType)(isModal, isInline), userType, doSelectUserType);

        case 15:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function takeLatestWithName(pattern, saga) {
  var task;
  return _regenerator2.default.wrap(function takeLatestWithName$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.fork)(_regenerator2.default.mark(function newSaga() {
            var lastTask, action;
            return _regenerator2.default.wrap(function newSaga$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    lastTask = {};

                  case 1:
                    if (!true) {
                      _context15.next = 13;
                      break;
                    }

                    _context15.next = 4;
                    return (0, _effects.take)(pattern);

                  case 4:
                    action = _context15.sent;

                    if (!(action.name in lastTask)) {
                      _context15.next = 8;
                      break;
                    }

                    _context15.next = 8;
                    return (0, _effects.cancel)(lastTask[action.name]);

                  case 8:
                    _context15.next = 10;
                    return (0, _effects.fork)(saga, action);

                  case 10:
                    lastTask[action.name] = _context15.sent;
                    _context15.next = 1;
                    break;

                  case 13:
                  case 'end':
                    return _context15.stop();
                }
              }
            }, newSaga, this);
          }));

        case 2:
          task = _context16.sent;
          return _context16.abrupt('return', task);

        case 4:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[14], this);
}

function isEmail(action) {
  return action.type === constant.VALIDATE_FIELD && action.name === 'registration.email';
}

function rootSaga() {
  return _regenerator2.default.wrap(function rootSaga$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return [(0, _reduxSaga.takeEvery)(constant.INIT_SIGN_IN, initSignIn), (0, _reduxSaga.takeEvery)(constant.INIT_REGISTER, initRegister), (0, _reduxSaga.takeEvery)(constant.INIT_GOOGLE_SIGN_IN, initGoogleSignIn), (0, _reduxSaga.takeEvery)(constant.INIT_FORGOT_PASSWORD, initForgotPassword), (0, _reduxSaga.takeEvery)(constant.SUCCESS_GOOGLE_SIGN_IN, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_SIGN_IN, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_REGISTER, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_FORGOT_PASSWORD, successForgotPassword), (0, _reduxSaga.takeEvery)(constant.UPDATE_USER_DATA, updateUserData), (0, _reduxSaga.takeEvery)(constant.INIT_SET_FORM_TYPE, initSetFormType), (0, _reduxSaga.takeEvery)(constant.FAIL_SIGN_IN, failSignIn), (0, _reduxSaga.takeEvery)(constant.FAIL_GOOGLE_SIGN_IN, failSignIn), (0, _reduxSaga.takeEvery)(constant.FAIL_REGISTER, failRegister), (0, _reduxSaga.takeEvery)(constant.TRACK_CLICK, trackClickSaga), (0, _reduxSaga.takeEvery)(constant.TRACK_DISPLAY, trackDisplaySaga), takeLatestWithName(constant.VALIDATE_FIELD, validateField), (0, _reduxSaga.throttle)(800, isEmail, suggestUserName)];

        case 2:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[15], this);
}

});
},{"137":137,"139":139,"141":141,"156":156,"16":16,"170":170,"171":171,"174":174,"175":175,"176":176,"177":177,"180":180,"27":27,"8":8}],180:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReloadURL = getReloadURL;
exports.getDoSelectUserType = getDoSelectUserType;
exports.getOnSuccess = getOnSuccess;
exports.getFormType = getFormType;
exports.getIsInline = getIsInline;
exports.getIsModal = getIsModal;
exports.getUserType = getUserType;
exports.getForgotPasswordData = getForgotPasswordData;
exports.getSignInData = getSignInData;
exports.getRegistrationData = getRegistrationData;
exports.getGoogleSignInData = getGoogleSignInData;

var _tracking = require(174);

function getReloadURL(state) {
  return state.common.reloadURL;
}

function getDoSelectUserType(state) {
  return state.common.doSelectUserType;
}

function getOnSuccess(state) {
  return state.common.onSuccess;
}

function getFormType(state) {
  return state.common.formType;
}

function getIsInline(state) {
  return state.common.isInline;
}

function getIsModal(state) {
  return state.common.isModal;
}

function getUserType(state) {
  return state.common.userType;
}

function getForgotPasswordData(state) {
  return { email: state.forgotPassword.identification };
}

function getSignInData(state) {
  var common = state.common;
  var signIn = state.signIn;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var identification = signIn.identification;
  var password = signIn.password;
  var trustedComputer = signIn.trustedComputer;
  var appId = common.appId;

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;

  var data = {
    appId: appId,
    identification: identification,
    password: password,
    trustedComputer: trustedComputer,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection
  };

  return data;
}

function getRegistrationData(state) {
  var common = state.common;
  var register = state.register;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var isModal = common.isModal;
  var isInline = common.isInline;
  var isStudent = common.userType === 'student';

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;

  var data = {
    username: register.username,
    email: register.email || '',
    password: register.password,
    userType: common.userType || null,
    newsletter: isStudent ? false : register.newsletter,
    regUrl: !isModal && !isInline ? common.rtn : window && window.location.href,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection,
    appId: common.appId
  };

  data.position = common.position || '';

  if (!common.omitName) {
    data.firstName = register.firstName;
    data.lastName = register.lastName;
  }

  return data;
}

function getGoogleSignInData(state) {
  var common = state.common;
  var register = state.register;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var isStudent = common.userType === 'student';
  var isModal = common.isModal;
  var isInline = common.isInline;

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;
  var regUrl = void 0;
  if (common.regUrl) {
    regUrl = common.regUrl;
  } else if (!isModal && !isInline) {
    regUrl = common.rtn;
  } else {
    regUrl = window && window.location.href;
  }

  var data = {
    isModal: isModal || isInline,
    userType: common.userType,
    newsletter: isStudent ? false : register.newsletter,
    regUrl: regUrl,
    appId: common.appId,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection,
    trustedComputer: state.signIn.trustedComputer,
    rtn: isModal || isInline ? '/oauth/close-modal' : common.rtn || window.location.href
  };

  data.position = common.position || '';

  return data;
}

});
},{"174":174,"8":8}],181:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

require(134);

var _es6ObjectAssign = require(129);

var _es6ObjectAssign2 = _interopRequireDefault(_es6ObjectAssign);

require(155);

var _reduxSaga = require(141);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactDom = __react_dom;

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __react_redux;

var _redux = __redux;

var _reducers = require(178);

var _reducers2 = _interopRequireDefault(_reducers);

var _App = require(157);

var _App2 = _interopRequireDefault(_App);

var _sagas = require(179);

var _sagas2 = _interopRequireDefault(_sagas);

var _actions = require(176);

var actions = _interopRequireWildcard(_actions);

var _utils = require(180);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var events = window.TES.events; // polyfills


_es6ObjectAssign2.default.polyfill();

var mountPointCls = 'app-auth-mountpoint';
var mountPoint = '.' + mountPointCls;

var bootstrap = function bootstrap() {
  var sagaMiddleware = (0, _reduxSaga2.default)();

  var mountElement = document.querySelector(mountPoint);
  mountElement.className = mountPointCls + '-loaded';
  var initialState = JSON.parse(mountElement.getAttribute('data-init-state'));

  var enhancer = (0, _redux.compose)((0, _redux.applyMiddleware)(sagaMiddleware));

  var store = (0, _redux.createStore)(_reducers2.default, initialState, enhancer);
  // then run the saga
  sagaMiddleware.run(_sagas2.default);

  var app = _react2.default.createElement(_App2.default);
  var provider = _react2.default.createElement(_reactRedux.Provider, { store: store }, app);

  _reactDom2.default.render(provider, mountElement);

  events.on('modal-switch', function (eventType, data) {
    if (data.appId === 'authapp') {
      store.dispatch(actions.initSetFormType(data.msg));
    }
  });
  // // this sends an event only when I am NOT changing the form type
  events.on(/modal-(switch|init)/, function (eventType, data) {
    var form = data.msg;
    if (data.appId === 'authapp' && form === (0, _utils.getFormType)(store.getState())) {
      store.dispatch(actions.trackClick(form));
    }
  });
};

if (document.querySelector(mountPoint)) {
  bootstrap(); // page init
} else {
  events.one('modal-init', bootstrap); // modal init
}

});
},{"129":129,"134":134,"141":141,"155":155,"157":157,"176":176,"178":178,"179":179,"180":180,"8":8}]},{},[181])
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
